import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from 'react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables>(client: GraphQLClient, query: string, variables?: TVariables, headers?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request<TData, TVariables>(query, variables, headers);
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** JavaScript Date object */
  Date: string;
  /** Parsing a monetary value based on the following regex: /^(?<currency>[A-Z]{3})[\s](?<amount>[-]?[\d]*(?:[.][\d]*)?)$/. */
  MonetaryAmount: string;
  /** JavaScript Date object as an UTC timestamp */
  UTCDateTime: string;
};

export type AccountOwnerAccount = {
  __typename?: 'AccountOwnerAccount';
  collateralAccountId: Scalars['String'];
};

export enum AccountSource {
  Manual = 'Manual',
  System = 'System'
}

export enum ActivityAuditType {
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  Read = 'READ',
  Search = 'SEARCH',
  Write = 'WRITE'
}

export type AlertFilter = {
  value: Scalars['String'];
};

export enum AlertStatus {
  Open = 'OPEN',
  Pending = 'PENDING',
  Resolved = 'RESOLVED'
}

export type AlertSummary = {
  __typename?: 'AlertSummary';
  count: Scalars['Int'];
  status: LoanStatus;
};

export type Application = {
  __typename?: 'Application';
  /** label: String */
  comments?: Maybe<Scalars['String']>;
  commitmentAmount?: Maybe<Scalars['Float']>;
  customerExternalId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  evaluationId?: Maybe<Scalars['String']>;
  formBundleId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastUpdateDate?: Maybe<Scalars['UTCDateTime']>;
  loanException?: Maybe<Scalars['String']>;
  loanPurpose?: Maybe<Scalars['String']>;
  loanType?: Maybe<Scalars['String']>;
  requestedLoanAmount?: Maybe<Scalars['Float']>;
  status?: Maybe<ApplicationStatus>;
};

export type ApplicationConfig = {
  __typename?: 'ApplicationConfig';
  applicationsActionModal: ApplicationsActionModalConfig;
  applicationsList: ApplicationsListConfig;
  collateralAccounts: CollateralAccountsConfig;
  creditPolicy: CreditPolicyConfig;
  customerDetailsV2: CustomerDetailsConfigV2;
  customerHeader: CustomerHeaderConfig;
  customerList: CustomerListConfig;
  dashboard: DashboardConfig;
  evaluation: EvaluationConfig;
  evaluationsActionModal: EvaluationsActionModalConfig;
  evaluationsList: EvaluationsListConfig;
  helpText: HelpTextConfig;
  internalContacts: InternalContactsConfig;
  labels: LabelsConfig;
  landing: LandingConfig;
  loanAccounts: LoanAccountsConfig;
  loanBlendedRates: LoanBlendedRatesConfig;
  loanDetailsInfo: LoanDetailsInfoConfig;
  loanInterestHistory: LoanInterestHistoryConfig;
  loanInterestPayments: LoanInterestPaymentsConfig;
  loanInterestRates: LoanInterestRatesConfig;
  loanKeyInformation: LoanKeyInformationConfig;
  loanMarginAnalysis: MarginAnalysisV2Config;
  loanOpportunity: LoanOpportunityConfig;
  loanPledgedAccounts: LoanPledgedAccountsConfig;
  loanProposal: LoanProposalConfig;
  partiesV2: PartiesConfigV2;
  pledgedAccountsSummary: PledgedAccountsSummaryConfig;
  portfolioOpportinity: PortfolioOpportinityConfig;
  portfolioSummary: PortfolioSummaryConfig;
  sideMenu: SideMenuConfig;
  theme: UiThemeConfig;
};

export type ApplicationFilter = {
  field: ApplicationFilterFields;
  value: Scalars['String'];
};

export enum ApplicationFilterFields {
  CustomerId = 'customerId'
}

export type ApplicationInput = {
  borrowerType?: InputMaybe<Scalars['String']>;
  customerId: Scalars['String'];
  evaluationId: Scalars['String'];
  exceptionRequest?: InputMaybe<Scalars['String']>;
  exceptionRequestRationale?: InputMaybe<Scalars['String']>;
  fees?: InputMaybe<Scalars['Float']>;
  floor?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  initialRate?: InputMaybe<Scalars['Float']>;
  interestRateType?: InputMaybe<Scalars['String']>;
  loanPurpose?: InputMaybe<Scalars['String']>;
  loanTerm?: InputMaybe<Scalars['String']>;
  loanType?: InputMaybe<Scalars['String']>;
  maxBorrowingPowerChecked: Scalars['Boolean'];
  primaryLoanPurpose?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  proposedPricing?: InputMaybe<Scalars['String']>;
  requestedLoanAmount: Scalars['Float'];
  spread?: InputMaybe<Scalars['Float']>;
};

export type ApplicationSavedResponse = {
  __typename?: 'ApplicationSavedResponse';
  formBundleId: Scalars['String'];
};

/** The search and pagination input passing through search field and page results and next page id */
export type ApplicationSearchInput = {
  /** Defaults to 0 */
  fromIndex?: InputMaybe<Scalars['Int']>;
  /** Defaults to 10 */
  numResults?: InputMaybe<Scalars['Int']>;
  /** Search text ignored when not searching */
  searchText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Array<ApplicationSearchSortByInput>>;
};

export type ApplicationSearchResponse = {
  __typename?: 'ApplicationSearchResponse';
  fromIndex: Scalars['Int'];
  items?: Maybe<Array<Maybe<ApplicationSearchResultItem>>>;
  numResults: Scalars['Int'];
  searchText?: Maybe<Scalars['String']>;
  totalHits: Scalars['Int'];
};

export type ApplicationSearchResultItem = {
  __typename?: 'ApplicationSearchResultItem';
  customerExternalId: Scalars['String'];
  customerId: Scalars['String'];
  customerName: Scalars['String'];
  formBundleId: Scalars['String'];
  id: Scalars['ID'];
  lastUpdateDate: Scalars['UTCDateTime'];
  requestedLoanAmount?: Maybe<Scalars['Float']>;
  status: ApplicationStatus;
};

export type ApplicationSearchSortByInput = {
  field: ApplicationSortableFieldEnum;
  order: SearchOrder;
};

export enum ApplicationSortableFieldEnum {
  CustomerNamePlain = 'customerNamePlain',
  FormBundleId = 'formBundleId',
  LastUpdateDate = 'lastUpdateDate',
  RequestedLoanAmount = 'requestedLoanAmount',
  Status = 'status'
}

export enum ApplicationStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  InitWorkflow = 'INIT_WORKFLOW',
  InWorkflow = 'IN_WORKFLOW',
  New = 'NEW',
  Submitted = 'SUBMITTED',
  UploadPending = 'UPLOAD_PENDING'
}

export type ApplicationsActionModalConfig = {
  __typename?: 'ApplicationsActionModalConfig';
  showFields: ApplicationsActionModalShowFields;
};

export type ApplicationsActionModalShowFields = {
  __typename?: 'ApplicationsActionModalShowFields';
  downloadDocument: Scalars['Boolean'];
  view: Scalars['Boolean'];
};

export type ApplicationsListConfig = {
  __typename?: 'ApplicationsListConfig';
  showFields: ApplicationsListShowFields;
};

export type ApplicationsListShowFields = {
  __typename?: 'ApplicationsListShowFields';
  actions: Scalars['Boolean'];
  customerName: Scalars['Boolean'];
  formBundleId: Scalars['Boolean'];
  lastUpdateDate: Scalars['Boolean'];
  requestedLoanAmount: Scalars['Boolean'];
  status: Scalars['Boolean'];
};

export type AssetHolding = {
  __typename?: 'AssetHolding';
  assetName?: Maybe<Scalars['String']>;
  /** The price of a single security */
  assetPrice?: Maybe<Scalars['MonetaryAmount']>;
  assetSubType?: Maybe<Scalars['String']>;
  assetSubTypeDetails?: Maybe<Scalars['String']>;
  assetType: Scalars['String'];
  /** Can this security be considered eligible to include as collateral */
  eligible?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lastUpdateDate?: Maybe<Scalars['UTCDateTime']>;
  /** The value of the asset holding (quantity * assetPrice) */
  marketValue?: Maybe<Scalars['MonetaryAmount']>;
  /** The quantity of this security that is held within the collateral account */
  quantity: Scalars['Float'];
  /** The id of the asset isin or cusip of the security */
  securityId: Scalars['String'];
};

export type AssetValuation = {
  __typename?: 'AssetValuation';
  advanceAmount: AssetValuationValue;
  advanceRate: Scalars['Float'];
  assetClass: Scalars['String'];
  assetId: Scalars['String'];
  assetSubClass: Scalars['String'];
  collateralAccountId: Scalars['String'];
  concentratedMarketValue: AssetValuationValue;
  concentrationPercentage: Scalars['Float'];
  eligibleMarketValue: AssetValuationValue;
  id: Scalars['ID'];
  marketUnitPrice: AssetValuationValue;
  marketValue: AssetValuationValue;
  name: Scalars['String'];
  quantity: Scalars['Float'];
  scalingFactor: Scalars['Float'];
  sellOutAmount: AssetValuationValue;
  sellOutRate: Scalars['Float'];
  ticker?: Maybe<Scalars['String']>;
  topUpAmount: AssetValuationValue;
  topUpRate: Scalars['Float'];
};

export type AssetValuationInput = {
  advanceAmount: AssetValuationValueInput;
  advanceRate: Scalars['Float'];
  assetClass: Scalars['String'];
  assetId: Scalars['String'];
  assetSubClass: Scalars['String'];
  collateralAccountId: Scalars['String'];
  concentratedMarketValue: AssetValuationValueInput;
  concentrationPercentage: Scalars['Float'];
  eligibleMarketValue: AssetValuationValueInput;
  id: Scalars['ID'];
  marketUnitPrice: AssetValuationValueInput;
  marketValue: AssetValuationValueInput;
  name: Scalars['String'];
  quantity: Scalars['Float'];
  scalingFactor: Scalars['Float'];
  sellOutAmount: AssetValuationValueInput;
  sellOutRate: Scalars['Float'];
  ticker?: InputMaybe<Scalars['String']>;
  topUpAmount: AssetValuationValueInput;
  topUpRate: Scalars['Float'];
};

export type AssetValuationValue = {
  __typename?: 'AssetValuationValue';
  currency: Scalars['String'];
  value: Scalars['Float'];
};

export type AssetValuationValueInput = {
  currency: Scalars['String'];
  value: Scalars['Float'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CollateralAccount = {
  __typename?: 'CollateralAccount';
  accountType?: Maybe<Scalars['String']>;
  assetHoldings?: Maybe<Array<Maybe<AssetHolding>>>;
  assetTotal?: Maybe<Array<Maybe<CollateralAssetTotal>>>;
  collateralAccountId: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  custodian?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ineligible?: Maybe<Scalars['Boolean']>;
  lastUpdateDate?: Maybe<Scalars['UTCDateTime']>;
  loanCollateral?: Maybe<Array<Maybe<LoanCollateral>>>;
  marketData?: Maybe<CollateralMarketData>;
  ownerDisplayName?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  pledged?: Maybe<Scalars['Boolean']>;
  secondaryCollateralAccountIds?: Maybe<Array<Maybe<SecondaryCollateralAccountId>>>;
  source?: Maybe<AccountSource>;
  totalApportioned?: Maybe<Scalars['Float']>;
};


export type CollateralAccountAssetHoldingsArgs = {
  customerId?: InputMaybe<Scalars['String']>;
};


export type CollateralAccountAssetTotalArgs = {
  customerId: Scalars['String'];
};

export type CollateralAccountsConfig = {
  __typename?: 'CollateralAccountsConfig';
  showFields: CollateralAccountsShowFields;
};

export type CollateralAccountsShowFields = {
  __typename?: 'CollateralAccountsShowFields';
  accountType: Scalars['Boolean'];
  apportionedAmounts: Scalars['Boolean'];
  collateralAccountId: Scalars['Boolean'];
  collateralValue: Scalars['Boolean'];
  custodian: Scalars['Boolean'];
  eligibleMarketValue: Scalars['Boolean'];
  marketValue: Scalars['Boolean'];
  pledged: Scalars['Boolean'];
  secondaryCollateralAccountId: Scalars['Boolean'];
  totalApportioned: Scalars['Boolean'];
};

export type CollateralAssetTotal = {
  __typename?: 'CollateralAssetTotal';
  assetSubType?: Maybe<Scalars['String']>;
  assetSubTypeDetails?: Maybe<Scalars['String']>;
  eligible?: Maybe<Scalars['Boolean']>;
  marketValue?: Maybe<Scalars['MonetaryAmount']>;
};

export type CollateralMarketData = {
  __typename?: 'CollateralMarketData';
  collateralAccountId: Scalars['String'];
  collateralValue?: Maybe<Scalars['Float']>;
  eligibleMarketValue?: Maybe<Scalars['Float']>;
  marketValue?: Maybe<Scalars['Float']>;
};

export type ColorSchema = {
  __typename?: 'ColorSchema';
  cyan: ColorTints;
  disabled: Scalars['String'];
  gray: ColorTints;
  green: ColorTints;
  indigo: ColorTints;
  lime: ColorTints;
  orange: ColorTints;
  pink: ColorTints;
  primary: ColorTints;
  primaryBg: Scalars['String'];
  primaryText: Scalars['String'];
  purple: ColorTints;
  red: ColorTints;
  secondary: ColorTints;
  secondaryBg: Scalars['String'];
  secondaryText: Scalars['String'];
  yellow: ColorTints;
};

export type ColorTints = {
  __typename?: 'ColorTints';
  _50: Scalars['String'];
  _100: Scalars['String'];
  _200: Scalars['String'];
  _300: Scalars['String'];
  _400: Scalars['String'];
  _500: Scalars['String'];
  _600: Scalars['String'];
  _700: Scalars['String'];
};

export enum CompareTo {
  CommitmentAmount = 'COMMITMENT_AMOUNT',
  MinimumBalance = 'MINIMUM_BALANCE',
  OutstandingBalance = 'OUTSTANDING_BALANCE'
}

export type ConfigurableField = {
  __typename?: 'ConfigurableField';
  label: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type CreditPolicy = {
  __typename?: 'CreditPolicy';
  description: Description;
  id: Scalars['ID'];
};

export type CreditPolicyConfig = {
  __typename?: 'CreditPolicyConfig';
  allowCreditPolicySelection: Scalars['Boolean'];
};

export enum Currency {
  Usd = 'USD'
}

export type Customer = {
  __typename?: 'Customer';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  collateralAccounts?: Maybe<Array<Maybe<CollateralAccount>>>;
  customerId: Scalars['ID'];
  dateOfBirth?: Maybe<Scalars['Date']>;
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  evaluations?: Maybe<Array<Maybe<Evaluation>>>;
  firstName?: Maybe<Scalars['String']>;
  /** Dependant on country, example SSN, PPS, Tax Number */
  govId?: Maybe<Scalars['String']>;
  governmentFederalTaxId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalContacts?: Maybe<Array<Maybe<InternalContact>>>;
  lastName?: Maybe<Scalars['String']>;
  lastUpdateDate?: Maybe<Scalars['UTCDateTime']>;
  loans?: Maybe<Array<Maybe<Loan>>>;
  metadata?: Maybe<Array<Maybe<Metadata>>>;
  middleInitial?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  /** @deprecated Use 'displayName'. */
  name: Scalars['String'];
  opportunity?: Maybe<Opportunity>;
  owner?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pledgedAccountSummary?: Maybe<PledgedAccountSummary>;
  /** The summary details for the customers portfolio */
  portfolioSummary?: Maybe<PortfolioSummary>;
  /** The highest severity of the loan status */
  serviceStatus?: Maybe<ServiceStatus>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /**
   * Sum of all the market values of all the assets on each of the holdings for
   * each collateral account, both pledged and unpledged
   */
  totalMarketValue?: Maybe<Scalars['Float']>;
  /** The following fields apply only to Legal Entity */
  type?: Maybe<Scalars['String']>;
  weightedInterestRate?: Maybe<Scalars['Float']>;
  zip?: Maybe<Scalars['String']>;
};


export type CustomerEvaluationsArgs = {
  filter?: InputMaybe<Array<InputMaybe<EvaluationFilter>>>;
};

export type CustomerActivities = {
  __typename?: 'CustomerActivities';
  activities: Array<Maybe<CustomerActivity>>;
  customerExternalId: Scalars['String'];
  customerId: Scalars['ID'];
  customerName?: Maybe<Scalars['String']>;
};

export type CustomerActivity = {
  __typename?: 'CustomerActivity';
  description: Scalars['String'];
  eventOccurredAt: Scalars['UTCDateTime'];
  id: Scalars['String'];
  read: Scalars['Boolean'];
  referenceId: Scalars['ID'];
  referenceType: CustomerActivityType;
};

export type CustomerActivitySearchInput = {
  fromIndex?: InputMaybe<Scalars['Int']>;
  numResults?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type CustomerActivitySearchResponse = {
  __typename?: 'CustomerActivitySearchResponse';
  fromIndex: Scalars['Int'];
  items?: Maybe<Array<Maybe<CustomerActivitySearchResponseItem>>>;
  numResults: Scalars['Int'];
  searchText?: Maybe<Scalars['String']>;
  totalHits: Scalars['Int'];
};

export type CustomerActivitySearchResponseItem = {
  __typename?: 'CustomerActivitySearchResponseItem';
  activitiesStats: CustomerActivityStat;
  customerExternalId: Scalars['String'];
  customerId: Scalars['ID'];
  customerName: Scalars['String'];
};

export type CustomerActivityStat = {
  __typename?: 'CustomerActivityStat';
  evaluation: Scalars['Float'];
  loan: Scalars['Float'];
  loanApplication: Scalars['Float'];
};

export enum CustomerActivityType {
  Evaluation = 'EVALUATION',
  Loan = 'LOAN',
  LoanApplication = 'LOAN_APPLICATION'
}

export type CustomerAlert = {
  __typename?: 'CustomerAlert';
  alertStatus?: Maybe<AlertStatus>;
  dateOpened: Scalars['Date'];
  deadline?: Maybe<Scalars['Date']>;
  fixAmount?: Maybe<Scalars['Float']>;
  loanId: Scalars['String'];
  obligorObligation: Scalars['String'];
  repaymentFixAmount?: Maybe<Scalars['Float']>;
  status: LoanStatus;
};

export type CustomerAlertsSearchInput = {
  fromIndex?: InputMaybe<Scalars['Int']>;
  numResults?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type CustomerAlertsSearchResponse = {
  __typename?: 'CustomerAlertsSearchResponse';
  fromIndex: Scalars['Int'];
  items?: Maybe<Array<Maybe<CustomerAlertsSearchResultItem>>>;
  numResults: Scalars['Int'];
  searchText?: Maybe<Scalars['String']>;
  totalHits: Scalars['Int'];
};

export type CustomerAlertsSearchResultItem = {
  __typename?: 'CustomerAlertsSearchResultItem';
  alerts: Array<Maybe<CustomerAlert>>;
  customerExternalId: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export type CustomerDetailsConfigV2 = {
  __typename?: 'CustomerDetailsConfigV2';
  showFields: CustomerDetailsShowFields;
};

export type CustomerDetailsShowFields = {
  __typename?: 'CustomerDetailsShowFields';
  address: Scalars['Boolean'];
  city: Scalars['Boolean'];
  dateOfBirth: Scalars['Boolean'];
  email: Scalars['Boolean'];
  extraInformation: Scalars['Boolean'];
  firstName: Scalars['Boolean'];
  govId: Scalars['Boolean'];
  governmentFederalTaxId: Scalars['Boolean'];
  lastName: Scalars['Boolean'];
  legalEntityName: Scalars['Boolean'];
  legalEntityRegisteredAddress: Scalars['Boolean'];
  legalEntityType: Scalars['Boolean'];
  middleInitial: Scalars['Boolean'];
  middleName: Scalars['Boolean'];
  name: Scalars['Boolean'];
  phone: Scalars['Boolean'];
  state: Scalars['Boolean'];
  title: Scalars['Boolean'];
  zip: Scalars['Boolean'];
};

export type CustomerHeaderConfig = {
  __typename?: 'CustomerHeaderConfig';
  showButtons: CustomerHeaderShowButtons;
};

export type CustomerHeaderShowButtons = {
  __typename?: 'CustomerHeaderShowButtons';
  releaseCollateral: Scalars['Boolean'];
  requestDrawdown: Scalars['Boolean'];
};

export type CustomerListColumnConfig = {
  __typename?: 'CustomerListColumnConfig';
  show: Scalars['Boolean'];
  width: Scalars['String'];
};

export type CustomerListConfig = {
  __typename?: 'CustomerListConfig';
  availability: CustomerListColumnConfig;
  customer: CustomerListColumnConfig;
  customerId: CustomerListColumnConfig;
  email: CustomerListColumnConfig;
  interestRate: CustomerListColumnConfig;
  numberOfLoans: CustomerListColumnConfig;
  phone: CustomerListColumnConfig;
  serviceStatus: CustomerListColumnConfig;
  totalCollateralValue: CustomerListColumnConfig;
  totalCommitmentAmount: CustomerListColumnConfig;
  totalMarketValue: CustomerListColumnConfig;
  totalOutstandingBalance: CustomerListColumnConfig;
};

export type CustomerLoanApplicationActivities = {
  __typename?: 'CustomerLoanApplicationActivities';
  activities: Array<Maybe<CustomerActivity>>;
  customerId?: Maybe<Scalars['ID']>;
};

export type CustomerLoanApplicationActivitiesSearchInput = {
  fromIndex?: InputMaybe<Scalars['Int']>;
  numResults?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type CustomerLoanApplicationActivitiesSearchResponse = {
  __typename?: 'CustomerLoanApplicationActivitiesSearchResponse';
  fromIndex: Scalars['Int'];
  items?: Maybe<Array<Maybe<CustomerLoanApplicationActivitiesSearchResponseItem>>>;
  numResults: Scalars['Int'];
  searchText?: Maybe<Scalars['String']>;
  totalHits: Scalars['Int'];
};

export type CustomerLoanApplicationActivitiesSearchResponseItem = {
  __typename?: 'CustomerLoanApplicationActivitiesSearchResponseItem';
  activities: Array<Maybe<CustomerActivity>>;
  customerExternalId: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

/** The search and pagination input passing through search field and page results and next page id */
export type CustomerSearchInput = {
  /** Defaults to 0 */
  fromIndex?: InputMaybe<Scalars['Int']>;
  /** Defaults to 10 */
  numResults?: InputMaybe<Scalars['Int']>;
  /** Search text ignored when not searching */
  searchText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Array<InputMaybe<CustomerSearchSortByInput>>>;
};

export type CustomerSearchResponse = {
  __typename?: 'CustomerSearchResponse';
  fromIndex: Scalars['Int'];
  items?: Maybe<Array<Maybe<CustomerSearchResultItem>>>;
  lastSearchIndex?: Maybe<Scalars['String']>;
  numResults: Scalars['Int'];
  searchText?: Maybe<Scalars['String']>;
  totalHits: Scalars['Int'];
};

export type CustomerSearchResultItem = {
  __typename?: 'CustomerSearchResultItem';
  availability?: Maybe<Scalars['Float']>;
  collateralAccountIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  customerId: Scalars['ID'];
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  govId?: Maybe<Scalars['String']>;
  governmentFederalTaxId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interestRate?: Maybe<Scalars['Float']>;
  numberOfLoans?: Maybe<Scalars['Int']>;
  obligors?: Maybe<Array<Maybe<Scalars['String']>>>;
  phone?: Maybe<Scalars['String']>;
  serviceStatus?: Maybe<LoanStatus>;
  totalCollateralValue?: Maybe<Scalars['Float']>;
  totalCommitments?: Maybe<Scalars['Float']>;
  /**
   * Sum of all the market values of all the assets on each of the holdings for
   * each collateral account, both pledged and unpledged
   */
  totalMarketValue?: Maybe<Scalars['Float']>;
  totalOutstandingBalance?: Maybe<Scalars['Float']>;
};

export type CustomerSearchSortByInput = {
  field: SortableFieldEnum;
  order: SearchOrder;
};

export type DashboardCard = {
  __typename?: 'DashboardCard';
  label: Scalars['String'];
  show: Scalars['Boolean'];
};

export type DashboardCards = {
  __typename?: 'DashboardCards';
  alerts?: Maybe<DashboardCard>;
  alertsToLoanRatio?: Maybe<DashboardCard>;
  balances?: Maybe<DashboardCard>;
  customer?: Maybe<DashboardCard>;
  customersActivity?: Maybe<DashboardCard>;
  holdingWatchlist?: Maybe<DashboardCard>;
  lendingOpportunities?: Maybe<DashboardCard>;
  loanApplicationActivityStatus?: Maybe<DashboardCard>;
  loans?: Maybe<DashboardCard>;
  sblInterestRates?: Maybe<DashboardCard>;
  sofrRates?: Maybe<DashboardCard>;
  stockNews?: Maybe<DashboardCard>;
  topClients?: Maybe<DashboardCard>;
};

export type DashboardConfig = {
  __typename?: 'DashboardConfig';
  sections: Array<DashboardSection>;
};

export type DashboardSection = {
  __typename?: 'DashboardSection';
  cards: DashboardCards;
  id: DashboardSectionName;
  label: Scalars['String'];
  show: Scalars['Boolean'];
};

export enum DashboardSectionName {
  Activity = 'activity',
  Market = 'market',
  Monitor = 'monitor',
  MyPractice = 'myPractice',
  Prospects = 'prospects'
}

export enum DataBarrierFunctionality {
  Home = 'home',
  Other = 'other'
}

export type DataFeed = {
  __typename?: 'DataFeed';
  /** Last update time of ETL processing */
  updated: Scalars['UTCDateTime'];
};

export type Description = {
  __typename?: 'Description';
  value: Scalars['String'];
};

export enum DetailSectionSubject {
  IndividualCustomer = 'individualCustomer',
  LegalEntity = 'legalEntity'
}

export type Evaluation = {
  __typename?: 'Evaluation';
  commitmentAmount?: Maybe<Scalars['Float']>;
  compareTo?: Maybe<Scalars['String']>;
  creditPolicyId?: Maybe<Scalars['String']>;
  customerExternalId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  evaluationAssetSummary: Array<EvaluationAssetSummary>;
  evaluationCollateralAccount: Array<EvaluationCollateralAccount>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  lastEvaluated?: Maybe<Scalars['UTCDateTime']>;
  lastUpdateDate?: Maybe<Scalars['UTCDateTime']>;
  selloutThreshold?: Maybe<Scalars['Float']>;
  status?: Maybe<EvaluationStatus>;
  topupThreshold?: Maybe<Scalars['Float']>;
};

export type EvaluationAsset = {
  assetId: Scalars['String'];
  currency: Currency;
  quantity: Scalars['Float'];
  type: Scalars['String'];
};

export type EvaluationAssetSummary = {
  __typename?: 'EvaluationAssetSummary';
  advanceRate: Scalars['Float'];
  assetType: Scalars['String'];
  collateralValue: Scalars['Float'];
  evaluation?: Maybe<Evaluation>;
  id?: Maybe<Scalars['ID']>;
  lastUpdateDate?: Maybe<Scalars['UTCDateTime']>;
  marketValue: Scalars['Float'];
};

export type EvaluationCollateralAccount = {
  __typename?: 'EvaluationCollateralAccount';
  accountType?: Maybe<Scalars['String']>;
  collateralAccountId?: Maybe<Scalars['String']>;
  custodian?: Maybe<Scalars['String']>;
  evaluationAssets?: Maybe<Array<Maybe<EvaluationCollateralAsset>>>;
  evaluationId: Scalars['String'];
  externalAccountId: Scalars['String'];
  id: Scalars['ID'];
  lastUpdateDate?: Maybe<Scalars['UTCDateTime']>;
  marketValue?: Maybe<Scalars['Float']>;
  ownerDisplayName?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  pledged?: Maybe<Scalars['Boolean']>;
  source?: Maybe<AccountSource>;
};

export type EvaluationCollateralAccountPayload = {
  accountType?: InputMaybe<Scalars['String']>;
  custodian?: InputMaybe<Scalars['String']>;
  evaluationAssets?: InputMaybe<Array<InputMaybe<EvaluationAsset>>>;
  externalAccountId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  lastUpdateDate?: InputMaybe<Scalars['UTCDateTime']>;
  ownerId?: InputMaybe<Scalars['String']>;
  pledged?: InputMaybe<Scalars['Boolean']>;
  source: AccountSource;
};

export type EvaluationCollateralAsset = {
  __typename?: 'EvaluationCollateralAsset';
  assetId: Scalars['String'];
  currency: Currency;
  id: Scalars['String'];
  quantity: Scalars['Float'];
  type: Scalars['String'];
};

export type EvaluationConfig = {
  __typename?: 'EvaluationConfig';
  compareTo: Scalars['String'];
  showButtons: EvaluationShowButtons;
};

/** The evaluation filter allows the results of the valuation to be filtered. */
export type EvaluationFilter = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EvaluationStatus>;
};

export type EvaluationInput = {
  collateralAccountIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  compareTo: Scalars['String'];
  creditPolicyId: Scalars['String'];
  customerId: Scalars['String'];
  customerName: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  evaluationCollateralAccounts: Array<InputMaybe<EvaluationCollateralAccountPayload>>;
  id: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  lastEvaluated: Scalars['UTCDateTime'];
};

/** The search and pagination input passing through search field and page results and next page id */
export type EvaluationSearchInput = {
  /** Defaults to 0 */
  fromIndex?: InputMaybe<Scalars['Int']>;
  /** Defaults to 10 */
  numResults?: InputMaybe<Scalars['Int']>;
  /** Search text ignored when not searching */
  searchText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Array<EvaluationSearchSortByInput>>;
};

export type EvaluationSearchResponse = {
  __typename?: 'EvaluationSearchResponse';
  fromIndex: Scalars['Int'];
  items?: Maybe<Array<Maybe<EvaluationSearchResultItem>>>;
  numResults: Scalars['Int'];
  searchText?: Maybe<Scalars['String']>;
  totalHits: Scalars['Int'];
};

export type EvaluationSearchResultItem = {
  __typename?: 'EvaluationSearchResultItem';
  commitmentAmount?: Maybe<Scalars['Float']>;
  customerExternalId: Scalars['String'];
  customerId: Scalars['String'];
  customerName: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['ID'];
  lastEvaluated: Scalars['UTCDateTime'];
  status: EvaluationStatus;
};

export type EvaluationSearchSortByInput = {
  field: EvaluationSortableFieldEnum;
  order: SearchOrder;
};

export type EvaluationShowButtons = {
  __typename?: 'EvaluationShowButtons';
  acquireUnpledgedAccounts: Scalars['Boolean'];
  addAccounts: Scalars['Boolean'];
  addCustomerAccounts: Scalars['Boolean'];
  addThirdPartyAccounts: Scalars['Boolean'];
  importAccountWithHoldings: Scalars['Boolean'];
  importViaCSV: Scalars['Boolean'];
};

export enum EvaluationSortableFieldEnum {
  CommitmentAmount = 'commitmentAmount',
  CustomerNamePlain = 'customerNamePlain',
  ExternalId = 'externalId',
  LastEvaluated = 'lastEvaluated',
  Status = 'status'
}

export enum EvaluationStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export type EvaluationToBeSaved = {
  __typename?: 'EvaluationToBeSaved';
  collateralAccountIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  commitmentAmount?: Maybe<Scalars['Float']>;
  compareTo?: Maybe<Scalars['String']>;
  creditPolicyId?: Maybe<Scalars['String']>;
  customerExternalId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  evaluationAssetSummary: Array<EvaluationAssetSummary>;
  externalId: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  lastEvaluated?: Maybe<Scalars['UTCDateTime']>;
  lastUpdateDate?: Maybe<Scalars['UTCDateTime']>;
  selloutThreshold?: Maybe<Scalars['Float']>;
  status?: Maybe<EvaluationStatus>;
  topupThreshold?: Maybe<Scalars['Float']>;
};

export type EvaluationsActionModalConfig = {
  __typename?: 'EvaluationsActionModalConfig';
  showFields: EvaluationsActionModalShowFields;
};

export type EvaluationsActionModalShowFields = {
  __typename?: 'EvaluationsActionModalShowFields';
  downloadPdf: Scalars['Boolean'];
  reEvaluate: Scalars['Boolean'];
  startApplication: Scalars['Boolean'];
  view: Scalars['Boolean'];
};

export type EvaluationsListConfig = {
  __typename?: 'EvaluationsListConfig';
  showFields: EvaluationsListShowFields;
};

export type EvaluationsListShowFields = {
  __typename?: 'EvaluationsListShowFields';
  actions: Scalars['Boolean'];
  commitmentAmount: Scalars['Boolean'];
  customerName: Scalars['Boolean'];
  externalId: Scalars['Boolean'];
  lastEvaluated: Scalars['Boolean'];
  status: Scalars['Boolean'];
};

export type FieldConfig = {
  __typename?: 'FieldConfig';
  label: Scalars['String'];
  show: Scalars['Boolean'];
  showDashOnDataIssue?: Maybe<Scalars['Boolean']>;
};

export enum FieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  Text = 'TEXT',
  Timestamp = 'TIMESTAMP'
}

export type FixedRatePeriod = {
  __typename?: 'FixedRatePeriod';
  feesShow: Scalars['Boolean'];
  fixedRatePeriodTerm?: Maybe<Array<Scalars['String']>>;
  initialRateShow: Scalars['Boolean'];
  termOtherShow: Scalars['Boolean'];
};

export type FixedVariableShow = {
  __typename?: 'FixedVariableShow';
  fixed: Scalars['Boolean'];
  variable: Scalars['Boolean'];
};

export type HelpTextConfig = {
  __typename?: 'HelpTextConfig';
  accountType?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  blendedAdvanceRate?: Maybe<Scalars['String']>;
  blendedSellOutRate?: Maybe<Scalars['String']>;
  blendedTopUpRate?: Maybe<Scalars['String']>;
  collateralAccountNumber?: Maybe<Scalars['String']>;
  collateralValue?: Maybe<Scalars['String']>;
  commitmentAmount?: Maybe<Scalars['String']>;
  custodian?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  evaluationId?: Maybe<Scalars['String']>;
  marketValue?: Maybe<Scalars['String']>;
  maxCommitmentAmount?: Maybe<Scalars['String']>;
  noInvoice?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  paymentAmount?: Maybe<Scalars['String']>;
  paymentDueDate?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['String']>;
  sellOutThreshold?: Maybe<Scalars['String']>;
  serviceStatus?: Maybe<ServiceStatusHelpText>;
  spread?: Maybe<Scalars['String']>;
  topUpThreshold?: Maybe<Scalars['String']>;
  totalCommitmentAmount?: Maybe<Scalars['String']>;
  unusedAccountInfo?: Maybe<Scalars['String']>;
};

export type InternalContact = {
  __typename?: 'InternalContact';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastUpdateDate?: Maybe<Scalars['UTCDateTime']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  role: Scalars['String'];
};

export type InternalContactInput = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type InternalContactsConfig = {
  __typename?: 'InternalContactsConfig';
  showFields: InternalContactsShowFields;
};

export type InternalContactsShowFields = {
  __typename?: 'InternalContactsShowFields';
  email: Scalars['Boolean'];
  name: Scalars['Boolean'];
  phone: Scalars['Boolean'];
  role: Scalars['Boolean'];
};

export type LabelsConfig = {
  __typename?: 'LabelsConfig';
  accountNumber: Scalars['String'];
  accountOwnerDetails: Scalars['String'];
  accountType: Scalars['String'];
  accounts: Scalars['String'];
  acquireUnpledgedAccounts: Scalars['String'];
  actions: Scalars['String'];
  addAccountsEvaluation: Scalars['String'];
  addAccountsInfo: Scalars['String'];
  addThirdParty: Scalars['String'];
  address: Scalars['String'];
  applications: Scalars['String'];
  applyForALoan: Scalars['String'];
  applyForLoanInfo: Scalars['String'];
  apportionedAmounts: Scalars['String'];
  assetType: Scalars['String'];
  autoRenewable: Scalars['String'];
  availability: Scalars['String'];
  backToSummary: Scalars['String'];
  blendedAdvanceRate: Scalars['String'];
  blendedRates: Scalars['String'];
  blendedSellOutRate: Scalars['String'];
  blendedTopUpRate: Scalars['String'];
  borrower: Scalars['String'];
  borrowerDetails: Scalars['String'];
  borrowerType: Scalars['String'];
  cash: Scalars['String'];
  chooseAccounts: Scalars['String'];
  chooseCreditPolicy: Scalars['String'];
  chooseCustomer: Scalars['String'];
  city: Scalars['String'];
  coBorrowers: Scalars['String'];
  collateralAccountId: Scalars['String'];
  collateralAccountNumber: Scalars['String'];
  collateralAccountNumbers: Scalars['String'];
  collateralValue: Scalars['String'];
  commitmentAmount: Scalars['String'];
  compareTo: Scalars['String'];
  creditPolicy: Scalars['String'];
  currentInterestRate: Scalars['String'];
  custodian: Scalars['String'];
  customer: Scalars['String'];
  customerDetails: Scalars['String'];
  customerId: Scalars['String'];
  customerProfile: Scalars['String'];
  customers: Scalars['String'];
  customersTableId: Scalars['String'];
  dailyInterest: Scalars['String'];
  date: Scalars['String'];
  dateOfBirth: Scalars['String'];
  details: Scalars['String'];
  downloadDocument: Scalars['String'];
  downloadPdf: Scalars['String'];
  eligibleForSBL: Scalars['String'];
  eligibleMarketValue: Scalars['String'];
  email: Scalars['String'];
  endDate: Scalars['String'];
  equity: Scalars['String'];
  etfs: Scalars['String'];
  evaluateInfo: Scalars['String'];
  evaluations: Scalars['String'];
  exceptionRequest: Scalars['String'];
  exceptionRequestPlaceholder: Scalars['String'];
  extraInformation: Scalars['String'];
  fees: Scalars['String'];
  firstName: Scalars['String'];
  fixedIncome: Scalars['String'];
  floor: Scalars['String'];
  floorRate: Scalars['String'];
  govId: Scalars['String'];
  governmentFederalTaxId: Scalars['String'];
  graphCannotBeDisplayed: Scalars['String'];
  guarantors: Scalars['String'];
  home: Scalars['String'];
  household: Scalars['String'];
  id: Scalars['String'];
  importAccountWithHoldings: Scalars['String'];
  ineligibles: Scalars['String'];
  initialRate: Scalars['String'];
  interestHistory: Scalars['String'];
  interestPayments: Scalars['String'];
  interestRate: Scalars['String'];
  interestRateType: Scalars['String'];
  interestRates: Scalars['String'];
  interestSinceInception: Scalars['String'];
  internalContactDetails: Scalars['String'];
  internalContacts: Scalars['String'];
  keyInformation: Scalars['String'];
  lastName: Scalars['String'];
  legalEntityName: Scalars['String'];
  legalEntityRegisteredAddress: Scalars['String'];
  legalEntityType: Scalars['String'];
  lendableAmount: Scalars['String'];
  loan: Scalars['String'];
  loanAmount: Scalars['String'];
  loanDetails: Scalars['String'];
  loanNumber: Scalars['String'];
  loanObligation: Scalars['String'];
  loanObligor: Scalars['String'];
  loanOrigination: Scalars['String'];
  loanParties: Scalars['String'];
  loanProposal: Scalars['String'];
  loanProposalType: Scalars['String'];
  loanPurpose: Scalars['String'];
  loanStatus: Scalars['String'];
  loanTerm: Scalars['String'];
  loanType: Scalars['String'];
  loans: Scalars['String'];
  marginAnalysis: Scalars['String'];
  marketValue: Scalars['String'];
  maxCommitmentAmount: Scalars['String'];
  middleInitial: Scalars['String'];
  middleName: Scalars['String'];
  minimumBalance: Scalars['String'];
  mtdInterest: Scalars['String'];
  mutualFunds: Scalars['String'];
  name: Scalars['String'];
  newEvaluation: Scalars['String'];
  noActiveAccounts: Scalars['String'];
  noContacts: Scalars['String'];
  numberOfLoans: Scalars['String'];
  opportunity: Scalars['String'];
  originations: Scalars['String'];
  otherLoanPurpose: Scalars['String'];
  outstandingBalance: Scalars['String'];
  owner: Scalars['String'];
  partiesInvolved: Scalars['String'];
  paymentAmount: Scalars['String'];
  paymentDueDate: Scalars['String'];
  phone: Scalars['String'];
  pledged: Scalars['String'];
  pledgedAccounts: Scalars['String'];
  pledgedAccountsSummary: Scalars['String'];
  portfolioSummary: Scalars['String'];
  potentialToBorrow: Scalars['String'];
  primaryLoanPurpose: Scalars['String'];
  priorYearInterest: Scalars['String'];
  productType: Scalars['String'];
  proposedPricing: Scalars['String'];
  rate: Scalars['String'];
  rateIndex: Scalars['String'];
  rateType: Scalars['String'];
  reEvaluate: Scalars['String'];
  reEvaluateInfo: Scalars['String'];
  remainingCollateralValue: Scalars['String'];
  remainingEligibleMarketValue: Scalars['String'];
  remainingMarketValue: Scalars['String'];
  reports: Scalars['String'];
  reviewYourSelection: Scalars['String'];
  role: Scalars['String'];
  secondaryCollateralAccountId: Scalars['String'];
  securityId: Scalars['String'];
  seeMore: Scalars['String'];
  seeProfile: Scalars['String'];
  selectAccountsCollateralGraph: Scalars['String'];
  selectManualAccounts: Scalars['String'];
  sellOutThreshold: Scalars['String'];
  serviceStatus: Scalars['String'];
  source: Scalars['String'];
  spread: Scalars['String'];
  ssn: Scalars['String'];
  startApplication: Scalars['String'];
  startDate: Scalars['String'];
  state: Scalars['String'];
  status: Scalars['String'];
  taxId: Scalars['String'];
  title: Scalars['String'];
  topUpCushion: Scalars['String'];
  topUpThreshold: Scalars['String'];
  totalApportioned: Scalars['String'];
  totalCollateralValue: Scalars['String'];
  totalCollateralView: Scalars['String'];
  totalCommitment: Scalars['String'];
  totalEligibleMarketValue: Scalars['String'];
  totalMarketValue: Scalars['String'];
  totalOutstandingBalance: Scalars['String'];
  totalRemainingEligibleMarketValue: Scalars['String'];
  totalRemainingMarketValue: Scalars['String'];
  units: Scalars['String'];
  utilization: Scalars['String'];
  view: Scalars['String'];
  viewFullCustomerProfile: Scalars['String'];
  weightedInterestRate: Scalars['String'];
  ytdInterestPaid: Scalars['String'];
  zip: Scalars['String'];
};

export type LandingConfig = {
  __typename?: 'LandingConfig';
  default: LandingPage;
};

export enum LandingPage {
  Applications = 'applications',
  Customers = 'customers',
  Dashboard = 'dashboard',
  Evaluations = 'evaluations'
}

export type Loan = {
  __typename?: 'Loan';
  /** last four symbols of bank account */
  accountNumber?: Maybe<Scalars['String']>;
  autoRenewable?: Maybe<Scalars['Boolean']>;
  /** " How much collateral is available to allocate */
  availability?: Maybe<Scalars['Float']>;
  blendedAdvanceRate?: Maybe<Scalars['Float']>;
  blendedSellOutRate?: Maybe<Scalars['Float']>;
  blendedTopUpRate?: Maybe<Scalars['Float']>;
  ceilingRate?: Maybe<Scalars['Float']>;
  /** " The value of the collateral */
  collateralValue?: Maybe<Scalars['Float']>;
  /** " The current commitment amount */
  commitmentAmount?: Maybe<Scalars['Float']>;
  compareTo?: Maybe<CompareTo>;
  creationDate: Scalars['UTCDateTime'];
  /** Interest rate and spread of the loan */
  currentInterestRate?: Maybe<Scalars['Float']>;
  /** A daily rate defines the amount of interest you are paying end of each day */
  dailyInterest?: Maybe<Scalars['Float']>;
  /**
   * " Amount of collateral value that is eligible
   * " to cover the loan
   */
  eligibleMarketValue?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['UTCDateTime']>;
  expirationDate?: Maybe<Scalars['UTCDateTime']>;
  fixAmount?: Maybe<Scalars['Float']>;
  floorRate?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** Explanation coming */
  interestAmount?: Maybe<Scalars['Float']>;
  /** Total Interest Paid since the inception of Loan */
  interestSinceInception?: Maybe<Scalars['Float']>;
  /** Is this loan cross collateralised */
  isCrossCollateralised?: Maybe<Scalars['Boolean']>;
  isOverAdvanced?: Maybe<Scalars['Boolean']>;
  lastUpdateDate: Scalars['UTCDateTime'];
  /** the collateral account link for this loan */
  loanCollateral?: Maybe<Array<Maybe<LoanCollateral>>>;
  /** " The obligor defined in the loan only */
  loanObligor?: Maybe<Scalars['String']>;
  /** " The collateral value according to latest prices */
  marketValue?: Maybe<Scalars['Float']>;
  minimumBalance?: Maybe<Scalars['Float']>;
  /** Month to Date Interest Rate */
  mtdInterest?: Maybe<Scalars['Float']>;
  /** when is the next payment due date */
  nextPaymentDueDate?: Maybe<Scalars['Date']>;
  obligation?: Maybe<Scalars['String']>;
  /** " The loan obligor or customer external ID */
  obligor?: Maybe<Scalars['String']>;
  /** " The current outstanding balance */
  outstandingBalance?: Maybe<Scalars['Float']>;
  /** Interest payment amount */
  paymentAmount?: Maybe<Scalars['Float']>;
  /** Interest paid last year */
  priorYearInterest?: Maybe<Scalars['Float']>;
  productType?: Maybe<Scalars['String']>;
  rateIndex?: Maybe<Scalars['String']>;
  rateType?: Maybe<RateType>;
  remainingCollateralValue?: Maybe<Scalars['Float']>;
  remainingEligibleMarketValue?: Maybe<Scalars['Float']>;
  remainingMarketValue?: Maybe<Scalars['Float']>;
  repaymentFixAmount?: Maybe<Scalars['Float']>;
  /** " The sell out threshold before an alert is generated */
  selloutThreshold?: Maybe<Scalars['Float']>;
  /** " The short name of the loan for display purposes */
  shortName: Scalars['String'];
  signers: Array<LoanSigner>;
  spread?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['UTCDateTime']>;
  /** " Is this loan in an alert status */
  status?: Maybe<LoanStatus>;
  topUpCushion?: Maybe<Scalars['Float']>;
  /** " The top up threshold before an alert is generated */
  topupThreshold?: Maybe<Scalars['Float']>;
  utilizationRate?: Maybe<Scalars['Float']>;
  /** Year to date amount of interest accrued */
  ytdInterestAccrued?: Maybe<Scalars['Float']>;
  /** Year to date amount of interest paid */
  ytdInterestPaid?: Maybe<Scalars['Float']>;
};

export type LoanAccountsConfig = {
  __typename?: 'LoanAccountsConfig';
  show: Scalars['Boolean'];
  showFields: LoanAccountsShowFields;
};

export type LoanAccountsShowFields = {
  __typename?: 'LoanAccountsShowFields';
  commitmentAmount: Scalars['Boolean'];
  loanNumber: Scalars['Boolean'];
  loanStatus: Scalars['Boolean'];
  outstandingBalance: Scalars['Boolean'];
  pledgedAccounts: Scalars['Boolean'];
};

export type LoanBlendedRatesConfig = {
  __typename?: 'LoanBlendedRatesConfig';
  show: Scalars['Boolean'];
  showFields: LoanBlendedRatesShowFields;
};

export type LoanBlendedRatesShowFields = {
  __typename?: 'LoanBlendedRatesShowFields';
  blendedAdvanceRate: Scalars['Boolean'];
  blendedSellOutRate: Scalars['Boolean'];
  blendedTopUpRate: Scalars['Boolean'];
};

export type LoanCollateral = {
  __typename?: 'LoanCollateral';
  /** The external id */
  accountId: Scalars['String'];
  /** The amount that was apportioned to the given loan */
  apportionedAmount?: Maybe<Scalars['Float']>;
  /** The internal collateral account id */
  collateralAccountId: Scalars['String'];
  /** The external loan ids */
  loanExternalId?: Maybe<Scalars['String']>;
  /** the internal loan id */
  loanId: Scalars['String'];
  obligation?: Maybe<Scalars['String']>;
  obligor?: Maybe<Scalars['String']>;
};

export type LoanComment = {
  __typename?: 'LoanComment';
  date: Scalars['UTCDateTime'];
  text: Scalars['String'];
};

export type LoanDetailsInfoConfig = {
  __typename?: 'LoanDetailsInfoConfig';
  show: Scalars['Boolean'];
  showFields: LoanDetailsInfoShowFields;
};

export type LoanDetailsInfoShowFields = {
  __typename?: 'LoanDetailsInfoShowFields';
  autoRenewable: Scalars['Boolean'];
  endDate: Scalars['Boolean'];
  loanObligation: Scalars['Boolean'];
  loanObligor: Scalars['Boolean'];
  loanStatus: Scalars['Boolean'];
  loanType: Scalars['Boolean'];
  startDate: Scalars['Boolean'];
};

export type LoanInput = {
  evaluation: Scalars['Boolean'];
  obligation: Scalars['String'];
  obligor: Scalars['String'];
  total: Scalars['Float'];
};

export type LoanInterestHistoryConfig = {
  __typename?: 'LoanInterestHistoryConfig';
  show: Scalars['Boolean'];
  showFields: LoanInterestHistoryShowFields;
};

export type LoanInterestHistoryShowFields = {
  __typename?: 'LoanInterestHistoryShowFields';
  dailyInterest: Scalars['Boolean'];
  interestSinceInception: Scalars['Boolean'];
  mtdInterest: Scalars['Boolean'];
  priorYearInterest: Scalars['Boolean'];
  ytdInterestPaid: Scalars['Boolean'];
};

export type LoanInterestPaymentsConfig = {
  __typename?: 'LoanInterestPaymentsConfig';
  show: Scalars['Boolean'];
  showFields: LoanInterestPaymentsShowFields;
};

export type LoanInterestPaymentsShowFields = {
  __typename?: 'LoanInterestPaymentsShowFields';
  accountNumber: Scalars['Boolean'];
  paymentAmount: Scalars['Boolean'];
  paymentDueDate: Scalars['Boolean'];
};

export type LoanInterestRatesConfig = {
  __typename?: 'LoanInterestRatesConfig';
  show: Scalars['Boolean'];
  showFields: LoanInterestRatesShowFields;
};

export type LoanInterestRatesShowFields = {
  __typename?: 'LoanInterestRatesShowFields';
  currentInterestRate: Scalars['Boolean'];
  floorRate: Scalars['Boolean'];
  rateIndex: Scalars['Boolean'];
  rateType: Scalars['Boolean'];
  spread: Scalars['Boolean'];
};

export type LoanKeyInformationConfig = {
  __typename?: 'LoanKeyInformationConfig';
  show: Scalars['Boolean'];
  showFields: LoanKeyInformationShowFields;
};

export type LoanKeyInformationShowFields = {
  __typename?: 'LoanKeyInformationShowFields';
  availability: Scalars['Boolean'];
  commitmentAmount: Scalars['Boolean'];
  compareTo: Scalars['Boolean'];
  minimumBalance: Scalars['Boolean'];
  outstandingBalance: Scalars['Boolean'];
  utilization: Scalars['Boolean'];
};

export type LoanOpportunityConfig = {
  __typename?: 'LoanOpportunityConfig';
  show: Scalars['Boolean'];
  showFields: LoanOpportunityShowFields;
};

export type LoanOpportunityShowFields = {
  __typename?: 'LoanOpportunityShowFields';
  lendableAmount: Scalars['Boolean'];
  potentialToBorrow: Scalars['Boolean'];
};

export type LoanPledgedAccountsConfig = {
  __typename?: 'LoanPledgedAccountsConfig';
  show: Scalars['Boolean'];
  showFields: LoanPledgedAccountsShowFields;
};

export type LoanPledgedAccountsShowFields = {
  __typename?: 'LoanPledgedAccountsShowFields';
  collateralValue: Scalars['Boolean'];
  eligibleMarketValue: Scalars['Boolean'];
  marketValue: Scalars['Boolean'];
  pledgedAccounts: Scalars['Boolean'];
  remainingCollateralValue: Scalars['Boolean'];
  remainingEligibleMarketValue: Scalars['Boolean'];
  remainingMarketValue: Scalars['Boolean'];
};

export type LoanProposalConfig = {
  __typename?: 'LoanProposalConfig';
  applicationSubmittedMsg: Scalars['String'];
  fieldsOptions: LoanProposalFieldsOptions;
  minimumLoanAmount?: Maybe<Scalars['Float']>;
  minimumLoanAmountWarning?: Maybe<Scalars['Float']>;
  rates: Array<LoanProposalRates>;
  showFields: LoanProposalShowFields;
};

export type LoanProposalFieldOptions = {
  __typename?: 'LoanProposalFieldOptions';
  defaultValue?: Maybe<Scalars['String']>;
  options: Array<Scalars['String']>;
  other: Scalars['Boolean'];
};

export type LoanProposalFieldsOptions = {
  __typename?: 'LoanProposalFieldsOptions';
  borrowerType: LoanProposalFieldOptions;
  exceptionRequest: LoanProposalFieldOptions;
  fixedRatePeriod: FixedRatePeriod;
  floorShow: FixedVariableShow;
  interestRateDefaultValue?: Maybe<Scalars['String']>;
  interestRateMarginShow: FixedVariableShow;
  loanIndex: LoanProposalFixedVariableField;
  loanPurpose: LoanProposalFieldOptions;
  loanTerm: LoanProposalFieldOptions;
  loanType: LoanProposalFieldOptions;
  primaryLoanPurpose?: Maybe<LoanProposalFieldOptions>;
  productType?: Maybe<LoanProposalFieldOptions>;
  spread?: Maybe<Scalars['Int']>;
};

export type LoanProposalFixedVariableField = {
  __typename?: 'LoanProposalFixedVariableField';
  defaultValue?: Maybe<Scalars['String']>;
  fixed?: Maybe<Array<Scalars['String']>>;
  variable?: Maybe<Array<Scalars['String']>>;
};

export type LoanProposalRates = {
  __typename?: 'LoanProposalRates';
  from?: Maybe<Scalars['Float']>;
  interestRateType: RateType;
  loanIndex?: Maybe<Scalars['String']>;
  loanTerm?: Maybe<Scalars['String']>;
  loanType: Scalars['String'];
  rates: Scalars['String'];
  spread?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Float']>;
};

export type LoanProposalShowFields = {
  __typename?: 'LoanProposalShowFields';
  borrowerType: Scalars['Boolean'];
  exceptionRequest: Scalars['Boolean'];
  exceptionRequestRationale: Scalars['Boolean'];
  fees: Scalars['Boolean'];
  floor: Scalars['Boolean'];
  initialRate: Scalars['Boolean'];
  interestRateType: Scalars['Boolean'];
  loanAmount: Scalars['Boolean'];
  loanPurpose: Scalars['Boolean'];
  loanTerm: Scalars['Boolean'];
  loanType: Scalars['Boolean'];
  primaryLoanPurpose: Scalars['Boolean'];
  productType: Scalars['Boolean'];
  proposedPricing: Scalars['Boolean'];
  spread: Scalars['Boolean'];
};

export type LoanSigner = {
  __typename?: 'LoanSigner';
  id: Scalars['ID'];
  primary: Scalars['Boolean'];
  role: LoanSignerRole;
  signer: Customer;
};

export enum LoanSignerRole {
  Borrower = 'BORROWER',
  CoBorrower = 'CO_BORROWER'
}

export enum LoanStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  DataIssue = 'DATA_ISSUE',
  OverAdvanced = 'OVER_ADVANCED',
  PaidOff = 'PAID_OFF',
  Prospect = 'PROSPECT',
  SellOut = 'SELL_OUT',
  TopUp = 'TOP_UP',
  Watch = 'WATCH'
}

export type MarginAnalysisFieldsConfig = {
  __typename?: 'MarginAnalysisFieldsConfig';
  eligibleMarketValue: Scalars['Boolean'];
  maxCommitmentAmount: Scalars['Boolean'];
  sellOutThreshold: Scalars['Boolean'];
  topUpCushion: Scalars['Boolean'];
  topUpThreshold: Scalars['Boolean'];
};

export type MarginAnalysisV2Config = {
  __typename?: 'MarginAnalysisV2Config';
  show: Scalars['Boolean'];
  showFields: MarginAnalysisFieldsConfig;
};

export type Metadata = {
  __typename?: 'Metadata';
  customerId: Scalars['ID'];
  fieldName: Scalars['String'];
  fieldType: FieldType;
  fieldValue?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']>;
  attachEvaluationPdf: Scalars['String'];
  saveApplication: ApplicationSavedResponse;
  saveEvaluation: EvaluationToBeSaved;
  triggerActivityAudit?: Maybe<Scalars['Boolean']>;
};


export type MutationAttachEvaluationPdfArgs = {
  formBundleId: Scalars['String'];
};


export type MutationSaveApplicationArgs = {
  application: ApplicationInput;
};


export type MutationSaveEvaluationArgs = {
  evaluation: EvaluationInput;
  evaluationDate: Scalars['String'];
};


export type MutationTriggerActivityAuditArgs = {
  activityType: ActivityAuditType;
  customerExternalId?: InputMaybe<Scalars['String']>;
  queryDetails?: InputMaybe<Scalars['String']>;
  resourceAccessed?: InputMaybe<Scalars['String']>;
};

export type Opportunity = {
  __typename?: 'Opportunity';
  /** Total interest rate calculated on the loan */
  lendableAmount?: Maybe<Scalars['Float']>;
  /** Interest rate index plus the additional interest rate charged by the bank to make the total interest rate */
  potentialToBorrow?: Maybe<Scalars['Float']>;
  /**
   * The amount of eligible(defined by a credit policy)
   * available market value after collateral aportionment calculations have occurred
   */
  totalRemainingEligibleMarketValue?: Maybe<Scalars['Float']>;
  /** The amount of available market value after collateral aportionment calculations have occurred */
  totalRemainingMarketValue?: Maybe<Scalars['Float']>;
};

export type ParsedAccount = {
  __typename?: 'ParsedAccount';
  account?: Maybe<CollateralAccount>;
  errors?: Maybe<Array<ParsedAssetError>>;
};

export enum ParsedAssetError {
  AccountExists = 'accountExists',
  Duplication = 'duplication',
  MissingInfo = 'missingInfo'
}

export type ParsedAssetsCsv = {
  __typename?: 'ParsedAssetsCSV';
  records: Array<ParsedAccount>;
};

export type PartiesConfigV2 = {
  __typename?: 'PartiesConfigV2';
  sections: Array<Maybe<PartiesSection>>;
  show: Scalars['Boolean'];
};

export type PartiesSection = {
  __typename?: 'PartiesSection';
  fields?: Maybe<Array<Maybe<PartiesSectionsFieldType>>>;
  show: Scalars['Boolean'];
  type: PartiesSectionType;
};

export type PartiesSectionFieldType = {
  __typename?: 'PartiesSectionFieldType';
  fieldName: PartiesSectionFieldTypeName;
  show: Scalars['Boolean'];
};

export enum PartiesSectionFieldTypeName {
  CollateralAccounts = 'collateralAccounts',
  CustomerExternalId = 'customerExternalId',
  GovId = 'govId',
  GovernmentFederalTaxId = 'governmentFederalTaxId',
  Type = 'type'
}

export enum PartiesSectionType {
  AccountOwnerDetails = 'accountOwnerDetails',
  Borrower = 'borrower',
  CoBorrowers = 'coBorrowers',
  Guarantors = 'guarantors'
}

export type PartiesSectionsFieldType = {
  __typename?: 'PartiesSectionsFieldType';
  type: DetailSectionSubject;
  values?: Maybe<Array<Maybe<PartiesSectionFieldType>>>;
};

export type Party = {
  __typename?: 'Party';
  /** Account Owner has only */
  collateralAccounts?: Maybe<Array<Maybe<AccountOwnerAccount>>>;
  /** Details of customer */
  customerExternalId: Scalars['ID'];
  displayName: Scalars['String'];
  govId?: Maybe<Scalars['String']>;
  governmentFederalTaxId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  relationship: PartyRelationship;
  type?: Maybe<Scalars['String']>;
};

export enum PartyRelationship {
  AccountOwner = 'ACCOUNT_OWNER',
  CoBorrower = 'CO_BORROWER',
  Guarantor = 'GUARANTOR',
  PrimaryBorrower = 'PRIMARY_BORROWER'
}

export type PledgedAccountSummary = {
  __typename?: 'PledgedAccountSummary';
  /** Sum of collateral value of all holdings of this customer */
  totalCollateralValue?: Maybe<Scalars['Float']>;
  /** Sum of eligible market value of all holdings of this customer */
  totalEligibleMarketValue?: Maybe<Scalars['Float']>;
  /** Sum of market value of all holdings of this customer */
  totalMarketValue?: Maybe<Scalars['Float']>;
};

export type PledgedAccountsSummaryConfig = {
  __typename?: 'PledgedAccountsSummaryConfig';
  show: Scalars['Boolean'];
  showFields: PledgedAccountsSummaryShowFields;
};

export type PledgedAccountsSummaryShowFields = {
  __typename?: 'PledgedAccountsSummaryShowFields';
  totalCollateralValue: Scalars['Boolean'];
  totalEligibleMarketValue: Scalars['Boolean'];
  totalMarketValue: Scalars['Boolean'];
};

export type PortfolioOpportinityConfig = {
  __typename?: 'PortfolioOpportinityConfig';
  show: Scalars['Boolean'];
  showFields: PortfolioOpportinityShowFields;
};

export type PortfolioOpportinityShowFields = {
  __typename?: 'PortfolioOpportinityShowFields';
  lendableAmount: Scalars['Boolean'];
  potentialToBorrow: Scalars['Boolean'];
  totalRemainingEligibleMarketValue: Scalars['Boolean'];
  totalRemainingMarketValue: Scalars['Boolean'];
};

export type PortfolioSummary = {
  __typename?: 'PortfolioSummary';
  /** Total Commitment Amount - Total Outstanding balance */
  availability?: Maybe<Scalars['Float']>;
  /** How many loans does this customer have? */
  numberOfLoans?: Maybe<Scalars['Int']>;
  /** Sum of Commitment amount of all Loans of this customer */
  totalCommitment?: Maybe<Scalars['Float']>;
  /** Sum of outstanding balance of all Loans for this customer */
  totalOutstandingBalance?: Maybe<Scalars['Float']>;
  /** ( (Total commitment amount - Total outstanding balance)/Total commitment * 100 ) */
  utilizationRate?: Maybe<Scalars['Float']>;
};

export type PortfolioSummaryConfig = {
  __typename?: 'PortfolioSummaryConfig';
  show: Scalars['Boolean'];
  showFields: PortfolioSummaryShowFields;
};

export type PortfolioSummaryShowFields = {
  __typename?: 'PortfolioSummaryShowFields';
  availability: Scalars['Boolean'];
  numberOfLoans: Scalars['Boolean'];
  totalCommitment: Scalars['Boolean'];
  totalOutstandingBalance: Scalars['Boolean'];
  utilization: Scalars['Boolean'];
  weightedInterestRate: Scalars['Boolean'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']>;
  alertsSummary: Array<Maybe<AlertSummary>>;
  application?: Maybe<Application>;
  applicationConfig: ApplicationConfig;
  /** paginated sorted and filtered applications */
  applicationsSearch: ApplicationSearchResponse;
  /** get list of credit policies */
  creditPolicies: Array<Maybe<CreditPolicy>>;
  customer: Customer;
  customerActivitiesByType?: Maybe<CustomerActivities>;
  customerActivitySearch: CustomerActivitySearchResponse;
  customerAlertsSearch: CustomerAlertsSearchResponse;
  customerLoanApplicationActivities?: Maybe<CustomerLoanApplicationActivities>;
  customerLoanApplicationActivitiesSearch: CustomerLoanApplicationActivitiesSearchResponse;
  customersList: CustomerSearchResponse;
  /** find the customer managed by the given user */
  customersSearch: CustomerSearchResponse;
  datafeed: DataFeed;
  /** find a evaluation by id */
  evaluation?: Maybe<Evaluation>;
  /** paginated sorted and filtered evaluations */
  evaluationsSearch: EvaluationSearchResponse;
  /** find a loan by id */
  loan?: Maybe<Loan>;
  loanComments: Array<Maybe<LoanComment>>;
  /** Find Loan Parties by loan id */
  loanParties: Array<Maybe<Party>>;
  parseAssetCSV?: Maybe<ParsedAssetsCsv>;
  releaseRequest: ReleaseRequest;
  releaseRequests: Array<Maybe<ReleaseRequest>>;
  /** run evaluation for collateral accounts */
  runEvaluation: EvaluationToBeSaved;
  unpledgedAccounts?: Maybe<ValidatedCollateralAccounts>;
  unpledgedAccountsManyCustomers?: Maybe<ValidatedCollateralAccounts>;
  userPermissions: UserPermissions;
};


export type QueryAlertsSummaryArgs = {
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
};


export type QueryApplicationArgs = {
  applicationId: Scalars['ID'];
};


export type QueryApplicationsSearchArgs = {
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
  searchInput: ApplicationSearchInput;
};


export type QueryCustomerArgs = {
  customerId: Scalars['String'];
};


export type QueryCustomerActivitiesByTypeArgs = {
  activityType: Scalars['String'];
  customerId: Scalars['ID'];
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
};


export type QueryCustomerActivitySearchArgs = {
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
  searchInput: CustomerActivitySearchInput;
};


export type QueryCustomerAlertsSearchArgs = {
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
  searchInput: CustomerAlertsSearchInput;
};


export type QueryCustomerLoanApplicationActivitiesArgs = {
  applicationId: Scalars['ID'];
  customerId: Scalars['ID'];
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
};


export type QueryCustomerLoanApplicationActivitiesSearchArgs = {
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
  searchInput: CustomerLoanApplicationActivitiesSearchInput;
};


export type QueryCustomersListArgs = {
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
  searchInput: CustomerSearchInput;
};


export type QueryCustomersSearchArgs = {
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
  searchInput: CustomerSearchInput;
};


export type QueryEvaluationArgs = {
  evaluationId: Scalars['String'];
};


export type QueryEvaluationsSearchArgs = {
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
  searchInput: EvaluationSearchInput;
};


export type QueryLoanArgs = {
  loanId: Scalars['String'];
};


export type QueryLoanCommentsArgs = {
  loanId: Scalars['String'];
};


export type QueryLoanPartiesArgs = {
  loanId: Scalars['String'];
};


export type QueryParseAssetCsvArgs = {
  csv: Scalars['String'];
  systemAccountIds: Array<Scalars['String']>;
};


export type QueryReleaseRequestArgs = {
  releaseRequestId: Scalars['String'];
};


export type QueryReleaseRequestsArgs = {
  customerId: Scalars['String'];
};


export type QueryRunEvaluationArgs = {
  runEvaluation: RunEvaluationInput;
};


export type QueryUnpledgedAccountsArgs = {
  customerId: Scalars['String'];
  systemAccountIds: Array<Scalars['String']>;
};


export type QueryUnpledgedAccountsManyCustomersArgs = {
  customerIds: Array<Scalars['String']>;
  systemAccountIds: Array<Scalars['String']>;
};

export enum RateType {
  Fixed = 'FIXED',
  Variable = 'VARIABLE'
}

export enum RawPermission {
  CanAccessEvaluationPdf = 'CAN_ACCESS_EVALUATION_PDF',
  CanAccessLoanPdf = 'CAN_ACCESS_LOAN_PDF',
  CanAcquireAccountHeldAway = 'CAN_ACQUIRE_ACCOUNT_HELD_AWAY',
  CanAddAccountManually = 'CAN_ADD_ACCOUNT_MANUALLY',
  CanCreateLoanApplication = 'CAN_CREATE_LOAN_APPLICATION',
  CanCreateModifyRunEvaluations = 'CAN_CREATE_MODIFY_RUN_EVALUATIONS',
  CanDownloadLoanDocs = 'CAN_DOWNLOAD_LOAN_DOCS',
  CanPerformDrawdownRequest = 'CAN_PERFORM_DRAWDOWN_REQUEST',
  CanPerformReleaseRequest = 'CAN_PERFORM_RELEASE_REQUEST',
  CanViewActivityNotifications = 'CAN_VIEW_ACTIVITY_NOTIFICATIONS',
  CanViewApplications = 'CAN_VIEW_APPLICATIONS',
  CanViewCollateralAccounts = 'CAN_VIEW_COLLATERAL_ACCOUNTS',
  /** Dashboard */
  CanViewCustomers = 'CAN_VIEW_CUSTOMERS',
  /** Originations */
  CanViewEvaluations = 'CAN_VIEW_EVALUATIONS',
  CanViewInternalContacts = 'CAN_VIEW_INTERNAL_CONTACTS',
  CanViewLoans = 'CAN_VIEW_LOANS'
}

export type ReleaseRequest = {
  __typename?: 'ReleaseRequest';
  amountReleased: Scalars['Float'];
  executedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  performDate: Scalars['UTCDateTime'];
  result?: Maybe<Scalars['String']>;
};

export type RunEvaluationInput = {
  creditPolicyId: Scalars['String'];
  evaluationCollateralAccounts: Array<InputMaybe<EvaluationCollateralAccountPayload>>;
  label: Scalars['String'];
  persist: Scalars['Boolean'];
};

export enum SearchOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SecondaryCollateralAccountId = {
  __typename?: 'SecondaryCollateralAccountId';
  collateralId: Scalars['String'];
  id: Scalars['ID'];
  secondaryCollateralId: Scalars['String'];
};

export type ServiceStatus = {
  __typename?: 'ServiceStatus';
  /** The priority of the status the lower the number the higher the priority, 1 is the highest */
  priority?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['Int']>;
  /** The highest severity status of all the loans for this customer */
  status?: Maybe<LoanStatus>;
};

export type ServiceStatusHelpText = {
  __typename?: 'ServiceStatusHelpText';
  dataIssue?: Maybe<Scalars['String']>;
  overAdvanced?: Maybe<Scalars['String']>;
  sellOut?: Maybe<Scalars['String']>;
  topUp?: Maybe<Scalars['String']>;
};

export type SideMenuConfig = {
  __typename?: 'SideMenuConfig';
  customers: SideMenuItem;
  home: SideMenuItem;
  originations: SideMenuItem;
  reports: SideMenuItem;
};

export type SideMenuItem = {
  __typename?: 'SideMenuItem';
  navKey: Scalars['String'];
  show: Scalars['Boolean'];
};

export enum SortableFieldEnum {
  Availability = 'availability',
  CustomerId = 'customerId',
  DisplayNamePlain = 'displayNamePlain',
  EmailPlain = 'emailPlain',
  InterestRate = 'interestRate',
  NumberOfLoans = 'numberOfLoans',
  PhonePlain = 'phonePlain',
  ServiceStatusPriority = 'serviceStatusPriority',
  TotalCollateralValue = 'totalCollateralValue',
  TotalCommitments = 'totalCommitments',
  TotalMarketValue = 'totalMarketValue',
  TotalOutstandingBalance = 'totalOutstandingBalance'
}

export type Subscription = {
  __typename?: 'Subscription';
  _empty?: Maybe<Scalars['String']>;
};

export enum ThemeOwner {
  Nav = 'nav',
  Pnc = 'pnc'
}

export type UiThemeConfig = {
  __typename?: 'UIThemeConfig';
  colorSchema: ColorSchema;
  owner: ThemeOwner;
};

export type UserPermissions = {
  __typename?: 'UserPermissions';
  canAccessEvaluationPdf?: Maybe<Scalars['Boolean']>;
  canAccessLoanPdf?: Maybe<Scalars['Boolean']>;
  canAcquireAccountHeldAway?: Maybe<Scalars['Boolean']>;
  canAddAccountManually?: Maybe<Scalars['Boolean']>;
  canCreateLoanApplication?: Maybe<Scalars['Boolean']>;
  canCreateModifyRunEvaluations?: Maybe<Scalars['Boolean']>;
  canDownloadLoanDocs?: Maybe<Scalars['Boolean']>;
  canPerformDrawdownRequest?: Maybe<Scalars['Boolean']>;
  canPerformReleaseRequest?: Maybe<Scalars['Boolean']>;
  canViewActivityNotifications?: Maybe<Scalars['Boolean']>;
  canViewApplications?: Maybe<Scalars['Boolean']>;
  canViewCollateralAccounts?: Maybe<Scalars['Boolean']>;
  /** Dashboard */
  canViewCustomers?: Maybe<Scalars['Boolean']>;
  /** Originations */
  canViewEvaluations?: Maybe<Scalars['Boolean']>;
  canViewInternalContacts?: Maybe<Scalars['Boolean']>;
  canViewLoans?: Maybe<Scalars['Boolean']>;
};

export type ValidatedCollateralAccounts = {
  __typename?: 'ValidatedCollateralAccounts';
  records: Array<ParsedAccount>;
  warning?: Maybe<Scalars['String']>;
};

export type AuditReportMutationVariables = Exact<{
  activityType: ActivityAuditType;
  resourceAccessed?: InputMaybe<Scalars['String']>;
  customerExternalId?: InputMaybe<Scalars['String']>;
  queryDetails?: InputMaybe<Scalars['String']>;
}>;


export type AuditReportMutation = { __typename?: 'Mutation', triggerActivityAudit?: boolean | null };

export type DatafeedQueryVariables = Exact<{ [key: string]: never; }>;


export type DatafeedQuery = { __typename?: 'Query', datafeed: { __typename?: 'DataFeed', updated: string } };

export type CreditPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditPoliciesQuery = { __typename?: 'Query', creditPolicies: Array<{ __typename?: 'CreditPolicy', id: string, description: { __typename?: 'Description', value: string } } | null> };

export type CollateralAccountsQueryVariables = Exact<{
  customerID: Scalars['String'];
}>;


export type CollateralAccountsQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', customerId: string, collateralAccounts?: Array<{ __typename?: 'CollateralAccount', id: string, collateralAccountId: string, accountType?: string | null, custodian?: string | null, pledged?: boolean | null, ineligible?: boolean | null, totalApportioned?: number | null, secondaryCollateralAccountIds?: Array<{ __typename?: 'SecondaryCollateralAccountId', secondaryCollateralId: string } | null> | null, marketData?: { __typename?: 'CollateralMarketData', marketValue?: number | null, eligibleMarketValue?: number | null, collateralValue?: number | null } | null, assetTotal?: Array<{ __typename?: 'CollateralAssetTotal', assetSubType?: string | null, assetSubTypeDetails?: string | null, marketValue?: string | null, eligible?: boolean | null } | null> | null, loanCollateral?: Array<{ __typename?: 'LoanCollateral', loanId: string, obligor?: string | null, obligation?: string | null, apportionedAmount?: number | null } | null> | null } | null> | null } };

export type CustomerDetailsQueryVariables = Exact<{
  customerID: Scalars['String'];
}>;


export type CustomerDetailsQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, displayName: string, customerId: string, firstName?: string | null, lastName?: string | null, title?: string | null, middleName?: string | null, middleInitial?: string | null, email?: string | null, phone?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, dateOfBirth?: string | null, govId?: string | null, type?: string | null, governmentFederalTaxId?: string | null, metadata?: Array<{ __typename?: 'Metadata', fieldType: FieldType, fieldName: string, fieldValue?: string | null } | null> | null } };

export type CustomerHeaderQueryVariables = Exact<{
  customerID: Scalars['String'];
}>;


export type CustomerHeaderQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, customerId: string, displayName: string, lastUpdateDate?: string | null, serviceStatus?: { __typename?: 'ServiceStatus', priority?: number | null, status?: LoanStatus | null } | null } };

export type CustomerLoansQueryVariables = Exact<{
  customerID: Scalars['String'];
}>;


export type CustomerLoansQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', customerId: string, displayName: string, loans?: Array<{ __typename?: 'Loan', id: string, obligor?: string | null, obligation?: string | null } | null> | null } };

export type CustomersListQueryVariables = Exact<{
  fromIndex: Scalars['Int'];
  numResults: Scalars['Int'];
  sortBy?: InputMaybe<Array<InputMaybe<CustomerSearchSortByInput>> | InputMaybe<CustomerSearchSortByInput>>;
}>;


export type CustomersListQuery = { __typename?: 'Query', customersList: { __typename?: 'CustomerSearchResponse', numResults: number, lastSearchIndex?: string | null, totalHits: number, items?: Array<{ __typename?: 'CustomerSearchResultItem', id: string, displayName: string, customerId: string, email?: string | null, phone?: string | null, govId?: string | null, interestRate?: number | null, obligors?: Array<string | null> | null, numberOfLoans?: number | null, governmentFederalTaxId?: string | null, collateralAccountIds?: Array<string | null> | null, serviceStatus?: LoanStatus | null, totalCollateralValue?: number | null, totalCommitments?: number | null, totalMarketValue?: number | null, totalOutstandingBalance?: number | null, availability?: number | null } | null> | null } };

export type CustomersSearchQueryVariables = Exact<{
  fromIndex: Scalars['Int'];
  numResults: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Array<InputMaybe<CustomerSearchSortByInput>> | InputMaybe<CustomerSearchSortByInput>>;
}>;


export type CustomersSearchQuery = { __typename?: 'Query', customersSearch: { __typename?: 'CustomerSearchResponse', numResults: number, lastSearchIndex?: string | null, totalHits: number, items?: Array<{ __typename?: 'CustomerSearchResultItem', id: string, displayName: string, customerId: string, email?: string | null, phone?: string | null, govId?: string | null, interestRate?: number | null, obligors?: Array<string | null> | null, numberOfLoans?: number | null, governmentFederalTaxId?: string | null, collateralAccountIds?: Array<string | null> | null, serviceStatus?: LoanStatus | null, totalCollateralValue?: number | null, totalCommitments?: number | null, totalMarketValue?: number | null, totalOutstandingBalance?: number | null, availability?: number | null } | null> | null } };

export type InternalContactsQueryVariables = Exact<{
  customerID: Scalars['String'];
}>;


export type InternalContactsQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', customerId: string, internalContacts?: Array<{ __typename?: 'InternalContact', id: string, name: string, role: string, phone?: string | null, email?: string | null } | null> | null } };

export type CustomisationQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomisationQuery = { __typename?: 'Query', applicationConfig: { __typename?: 'ApplicationConfig', theme: { __typename?: 'UIThemeConfig', owner: ThemeOwner, colorSchema: { __typename?: 'ColorSchema', secondaryBg: string, primaryBg: string, primaryText: string, secondaryText: string, disabled: string, primary: { __typename?: 'ColorTints', _700: string, _600: string, _500: string, _400: string, _300: string, _200: string, _100: string, _50: string }, secondary: { __typename?: 'ColorTints', _700: string, _600: string, _500: string, _400: string, _300: string, _200: string, _100: string, _50: string }, gray: { __typename?: 'ColorTints', _700: string, _600: string, _500: string, _400: string, _300: string, _200: string, _100: string, _50: string }, green: { __typename?: 'ColorTints', _700: string, _600: string, _500: string, _400: string, _300: string, _200: string, _100: string, _50: string }, red: { __typename?: 'ColorTints', _700: string, _600: string, _500: string, _400: string, _300: string, _200: string, _100: string, _50: string }, pink: { __typename?: 'ColorTints', _700: string, _600: string, _500: string, _400: string, _300: string, _200: string, _100: string, _50: string }, purple: { __typename?: 'ColorTints', _700: string, _600: string, _500: string, _400: string, _300: string, _200: string, _100: string, _50: string }, indigo: { __typename?: 'ColorTints', _700: string, _600: string, _500: string, _400: string, _300: string, _200: string, _100: string, _50: string }, cyan: { __typename?: 'ColorTints', _700: string, _600: string, _500: string, _400: string, _300: string, _200: string, _100: string, _50: string }, lime: { __typename?: 'ColorTints', _700: string, _600: string, _500: string, _400: string, _300: string, _200: string, _100: string, _50: string }, yellow: { __typename?: 'ColorTints', _700: string, _600: string, _500: string, _400: string, _300: string, _200: string, _100: string, _50: string }, orange: { __typename?: 'ColorTints', _700: string, _600: string, _500: string, _400: string, _300: string, _200: string, _100: string, _50: string } } }, sideMenu: { __typename?: 'SideMenuConfig', home: { __typename?: 'SideMenuItem', navKey: string, show: boolean }, customers: { __typename?: 'SideMenuItem', navKey: string, show: boolean }, originations: { __typename?: 'SideMenuItem', navKey: string, show: boolean }, reports: { __typename?: 'SideMenuItem', navKey: string, show: boolean } }, partiesV2: { __typename?: 'PartiesConfigV2', show: boolean, sections: Array<{ __typename?: 'PartiesSection', show: boolean, type: PartiesSectionType, fields?: Array<{ __typename?: 'PartiesSectionsFieldType', type: DetailSectionSubject, values?: Array<{ __typename?: 'PartiesSectionFieldType', fieldName: PartiesSectionFieldTypeName, show: boolean } | null> | null } | null> | null } | null> }, labels: { __typename?: 'LabelsConfig', accountNumber: string, accountOwnerDetails: string, accountType: string, accounts: string, acquireUnpledgedAccounts: string, actions: string, addAccountsEvaluation: string, addAccountsInfo: string, address: string, addThirdParty: string, applications: string, applyForALoan: string, applyForLoanInfo: string, apportionedAmounts: string, assetType: string, autoRenewable: string, availability: string, backToSummary: string, blendedAdvanceRate: string, blendedRates: string, blendedSellOutRate: string, blendedTopUpRate: string, borrower: string, borrowerDetails: string, borrowerType: string, cash: string, chooseAccounts: string, chooseCreditPolicy: string, chooseCustomer: string, city: string, coBorrowers: string, collateralAccountId: string, collateralAccountNumbers: string, collateralAccountNumber: string, collateralValue: string, commitmentAmount: string, compareTo: string, creditPolicy: string, currentInterestRate: string, custodian: string, customerDetails: string, customer: string, customers: string, customerId: string, customerProfile: string, customersTableId: string, dailyInterest: string, date: string, dateOfBirth: string, details: string, downloadDocument: string, downloadPdf: string, eligibleForSBL: string, eligibleMarketValue: string, email: string, endDate: string, equity: string, etfs: string, evaluateInfo: string, evaluations: string, exceptionRequest: string, exceptionRequestPlaceholder: string, extraInformation: string, fees: string, firstName: string, fixedIncome: string, floor: string, floorRate: string, govId: string, governmentFederalTaxId: string, graphCannotBeDisplayed: string, guarantors: string, home: string, household: string, id: string, importAccountWithHoldings: string, ineligibles: string, initialRate: string, interestHistory: string, interestPayments: string, interestRate: string, interestRates: string, interestRateType: string, interestSinceInception: string, internalContactDetails: string, internalContacts: string, keyInformation: string, lastName: string, legalEntityName: string, legalEntityRegisteredAddress: string, legalEntityType: string, lendableAmount: string, loan: string, loanAmount: string, loanDetails: string, loanNumber: string, loanObligation: string, loanObligor: string, loanOrigination: string, loanParties: string, loanProposal: string, loanProposalType: string, loanPurpose: string, loanStatus: string, loanTerm: string, loanType: string, loans: string, marginAnalysis: string, marketValue: string, maxCommitmentAmount: string, middleInitial: string, middleName: string, minimumBalance: string, mtdInterest: string, mutualFunds: string, name: string, newEvaluation: string, noActiveAccounts: string, noContacts: string, numberOfLoans: string, opportunity: string, originations: string, otherLoanPurpose: string, outstandingBalance: string, owner: string, partiesInvolved: string, paymentAmount: string, paymentDueDate: string, phone: string, pledged: string, pledgedAccounts: string, pledgedAccountsSummary: string, portfolioSummary: string, potentialToBorrow: string, primaryLoanPurpose: string, productType: string, priorYearInterest: string, proposedPricing: string, rate: string, rateIndex: string, rateType: string, reEvaluate: string, reEvaluateInfo: string, remainingCollateralValue: string, remainingEligibleMarketValue: string, remainingMarketValue: string, reports: string, reviewYourSelection: string, role: string, secondaryCollateralAccountId: string, securityId: string, seeMore: string, seeProfile: string, selectAccountsCollateralGraph: string, selectManualAccounts: string, sellOutThreshold: string, serviceStatus: string, source: string, spread: string, ssn: string, startApplication: string, startDate: string, state: string, status: string, taxId: string, title: string, topUpCushion: string, topUpThreshold: string, totalApportioned: string, totalCollateralValue: string, totalCollateralView: string, totalCommitment: string, totalEligibleMarketValue: string, totalMarketValue: string, totalOutstandingBalance: string, totalRemainingEligibleMarketValue: string, totalRemainingMarketValue: string, units: string, utilization: string, view: string, viewFullCustomerProfile: string, weightedInterestRate: string, ytdInterestPaid: string, zip: string }, loanDetailsInfo: { __typename?: 'LoanDetailsInfoConfig', show: boolean, showFields: { __typename?: 'LoanDetailsInfoShowFields', autoRenewable: boolean, loanStatus: boolean, loanObligor: boolean, loanObligation: boolean, loanType: boolean, startDate: boolean, endDate: boolean } }, loanKeyInformation: { __typename?: 'LoanKeyInformationConfig', show: boolean, showFields: { __typename?: 'LoanKeyInformationShowFields', utilization: boolean, availability: boolean, commitmentAmount: boolean, outstandingBalance: boolean, compareTo: boolean, minimumBalance: boolean } }, loanInterestRates: { __typename?: 'LoanInterestRatesConfig', show: boolean, showFields: { __typename?: 'LoanInterestRatesShowFields', currentInterestRate: boolean, rateType: boolean, rateIndex: boolean, spread: boolean, floorRate: boolean } }, loanInterestPayments: { __typename?: 'LoanInterestPaymentsConfig', show: boolean, showFields: { __typename?: 'LoanInterestPaymentsShowFields', paymentDueDate: boolean, paymentAmount: boolean, accountNumber: boolean } }, loanInterestHistory: { __typename?: 'LoanInterestHistoryConfig', show: boolean, showFields: { __typename?: 'LoanInterestHistoryShowFields', interestSinceInception: boolean, dailyInterest: boolean, mtdInterest: boolean, priorYearInterest: boolean, ytdInterestPaid: boolean } }, loanPledgedAccounts: { __typename?: 'LoanPledgedAccountsConfig', show: boolean, showFields: { __typename?: 'LoanPledgedAccountsShowFields', marketValue: boolean, eligibleMarketValue: boolean, collateralValue: boolean, remainingMarketValue: boolean, remainingEligibleMarketValue: boolean, remainingCollateralValue: boolean, pledgedAccounts: boolean } }, loanOpportunity: { __typename?: 'LoanOpportunityConfig', show: boolean, showFields: { __typename?: 'LoanOpportunityShowFields', lendableAmount: boolean, potentialToBorrow: boolean } }, portfolioSummary: { __typename?: 'PortfolioSummaryConfig', show: boolean, showFields: { __typename?: 'PortfolioSummaryShowFields', numberOfLoans: boolean, utilization: boolean, totalCommitment: boolean, totalOutstandingBalance: boolean, availability: boolean, weightedInterestRate: boolean } }, portfolioOpportinity: { __typename?: 'PortfolioOpportinityConfig', show: boolean, showFields: { __typename?: 'PortfolioOpportinityShowFields', lendableAmount: boolean, potentialToBorrow: boolean, totalRemainingMarketValue: boolean, totalRemainingEligibleMarketValue: boolean } }, pledgedAccountsSummary: { __typename?: 'PledgedAccountsSummaryConfig', show: boolean, showFields: { __typename?: 'PledgedAccountsSummaryShowFields', totalMarketValue: boolean, totalEligibleMarketValue: boolean, totalCollateralValue: boolean } }, loanAccounts: { __typename?: 'LoanAccountsConfig', show: boolean, showFields: { __typename?: 'LoanAccountsShowFields', loanNumber: boolean, loanStatus: boolean, commitmentAmount: boolean, outstandingBalance: boolean, pledgedAccounts: boolean } }, loanBlendedRates: { __typename?: 'LoanBlendedRatesConfig', show: boolean, showFields: { __typename?: 'LoanBlendedRatesShowFields', blendedAdvanceRate: boolean, blendedTopUpRate: boolean, blendedSellOutRate: boolean } }, loanMarginAnalysis: { __typename?: 'MarginAnalysisV2Config', show: boolean, showFields: { __typename?: 'MarginAnalysisFieldsConfig', eligibleMarketValue: boolean, maxCommitmentAmount: boolean, sellOutThreshold: boolean, topUpThreshold: boolean, topUpCushion: boolean } }, customerList: { __typename?: 'CustomerListConfig', customerId: { __typename?: 'CustomerListColumnConfig', show: boolean, width: string }, customer: { __typename?: 'CustomerListColumnConfig', show: boolean, width: string }, email: { __typename?: 'CustomerListColumnConfig', show: boolean, width: string }, phone: { __typename?: 'CustomerListColumnConfig', show: boolean, width: string }, totalCollateralValue: { __typename?: 'CustomerListColumnConfig', show: boolean, width: string }, totalMarketValue: { __typename?: 'CustomerListColumnConfig', show: boolean, width: string }, numberOfLoans: { __typename?: 'CustomerListColumnConfig', show: boolean, width: string }, totalCommitmentAmount: { __typename?: 'CustomerListColumnConfig', show: boolean, width: string }, totalOutstandingBalance: { __typename?: 'CustomerListColumnConfig', show: boolean, width: string }, interestRate: { __typename?: 'CustomerListColumnConfig', show: boolean, width: string }, availability: { __typename?: 'CustomerListColumnConfig', show: boolean, width: string }, serviceStatus: { __typename?: 'CustomerListColumnConfig', show: boolean, width: string } }, applicationsList: { __typename?: 'ApplicationsListConfig', showFields: { __typename?: 'ApplicationsListShowFields', customerName: boolean, formBundleId: boolean, lastUpdateDate: boolean, requestedLoanAmount: boolean, status: boolean, actions: boolean } }, evaluationsList: { __typename?: 'EvaluationsListConfig', showFields: { __typename?: 'EvaluationsListShowFields', customerName: boolean, externalId: boolean, lastEvaluated: boolean, commitmentAmount: boolean, status: boolean, actions: boolean } }, applicationsActionModal: { __typename?: 'ApplicationsActionModalConfig', showFields: { __typename?: 'ApplicationsActionModalShowFields', view: boolean, downloadDocument: boolean } }, evaluationsActionModal: { __typename?: 'EvaluationsActionModalConfig', showFields: { __typename?: 'EvaluationsActionModalShowFields', view: boolean, reEvaluate: boolean, startApplication: boolean, downloadPdf: boolean } }, collateralAccounts: { __typename?: 'CollateralAccountsConfig', showFields: { __typename?: 'CollateralAccountsShowFields', collateralAccountId: boolean, secondaryCollateralAccountId: boolean, accountType: boolean, custodian: boolean, marketValue: boolean, eligibleMarketValue: boolean, collateralValue: boolean, totalApportioned: boolean, pledged: boolean, apportionedAmounts: boolean } }, customerDetailsV2: { __typename?: 'CustomerDetailsConfigV2', showFields: { __typename?: 'CustomerDetailsShowFields', name: boolean, firstName: boolean, lastName: boolean, title: boolean, middleName: boolean, middleInitial: boolean, email: boolean, phone: boolean, city: boolean, state: boolean, zip: boolean, dateOfBirth: boolean, address: boolean, govId: boolean, legalEntityType: boolean, legalEntityName: boolean, legalEntityRegisteredAddress: boolean, governmentFederalTaxId: boolean, extraInformation: boolean } }, internalContacts: { __typename?: 'InternalContactsConfig', showFields: { __typename?: 'InternalContactsShowFields', name: boolean, role: boolean, email: boolean, phone: boolean } }, dashboard: { __typename?: 'DashboardConfig', sections: Array<{ __typename?: 'DashboardSection', id: DashboardSectionName, label: string, show: boolean, cards: { __typename?: 'DashboardCards', customersActivity?: { __typename?: 'DashboardCard', label: string, show: boolean } | null, loanApplicationActivityStatus?: { __typename?: 'DashboardCard', label: string, show: boolean } | null, alerts?: { __typename?: 'DashboardCard', label: string, show: boolean } | null, alertsToLoanRatio?: { __typename?: 'DashboardCard', label: string, show: boolean } | null, lendingOpportunities?: { __typename?: 'DashboardCard', label: string, show: boolean } | null, topClients?: { __typename?: 'DashboardCard', label: string, show: boolean } | null, customer?: { __typename?: 'DashboardCard', label: string, show: boolean } | null, loans?: { __typename?: 'DashboardCard', label: string, show: boolean } | null, balances?: { __typename?: 'DashboardCard', label: string, show: boolean } | null, sblInterestRates?: { __typename?: 'DashboardCard', label: string, show: boolean } | null, sofrRates?: { __typename?: 'DashboardCard', label: string, show: boolean } | null, holdingWatchlist?: { __typename?: 'DashboardCard', label: string, show: boolean } | null, stockNews?: { __typename?: 'DashboardCard', label: string, show: boolean } | null } }> }, evaluation: { __typename?: 'EvaluationConfig', compareTo: string, showButtons: { __typename?: 'EvaluationShowButtons', acquireUnpledgedAccounts: boolean, importAccountWithHoldings: boolean, addAccounts: boolean, addCustomerAccounts: boolean, addThirdPartyAccounts: boolean, importViaCSV: boolean } }, customerHeader: { __typename?: 'CustomerHeaderConfig', showButtons: { __typename?: 'CustomerHeaderShowButtons', releaseCollateral: boolean, requestDrawdown: boolean } }, helpText: { __typename?: 'HelpTextConfig', collateralValue?: string | null, endDate?: string | null, blendedAdvanceRate?: string | null, blendedTopUpRate?: string | null, blendedSellOutRate?: string | null, paymentDueDate?: string | null, paymentAmount?: string | null, noInvoice?: string | null, commitmentAmount?: string | null, totalCommitmentAmount?: string | null, collateralAccountNumber?: string | null, accountType?: string | null, custodian?: string | null, marketValue?: string | null, owner?: string | null, maxCommitmentAmount?: string | null, topUpThreshold?: string | null, sellOutThreshold?: string | null, spread?: string | null, assetType?: string | null, rate?: string | null, evaluationId?: string | null, unusedAccountInfo?: string | null, serviceStatus?: { __typename?: 'ServiceStatusHelpText', sellOut?: string | null, topUp?: string | null, overAdvanced?: string | null, dataIssue?: string | null } | null }, creditPolicy: { __typename?: 'CreditPolicyConfig', allowCreditPolicySelection: boolean }, landing: { __typename?: 'LandingConfig', default: LandingPage } } };

export type CustomerActivitiesByTypeQueryVariables = Exact<{
  customerId: Scalars['ID'];
  activityType: Scalars['String'];
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
}>;


export type CustomerActivitiesByTypeQuery = { __typename?: 'Query', customerActivitiesByType?: { __typename?: 'CustomerActivities', activities: Array<{ __typename?: 'CustomerActivity', id: string, description: string, referenceType: CustomerActivityType, referenceId: string, eventOccurredAt: string } | null> } | null };

export type CustomerActivitySearchQueryVariables = Exact<{
  fromIndex: Scalars['Int'];
  numResults: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
}>;


export type CustomerActivitySearchQuery = { __typename?: 'Query', customerActivitySearch: { __typename?: 'CustomerActivitySearchResponse', totalHits: number, numResults: number, fromIndex: number, searchText?: string | null, items?: Array<{ __typename?: 'CustomerActivitySearchResponseItem', customerId: string, customerExternalId: string, customerName: string, activitiesStats: { __typename?: 'CustomerActivityStat', evaluation: number, loanApplication: number, loan: number } } | null> | null } };

export type CustomerAlertsSearchQueryVariables = Exact<{
  fromIndex: Scalars['Int'];
  numResults: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
}>;


export type CustomerAlertsSearchQuery = { __typename?: 'Query', customerAlertsSearch: { __typename?: 'CustomerAlertsSearchResponse', totalHits: number, numResults: number, fromIndex: number, searchText?: string | null, items?: Array<{ __typename?: 'CustomerAlertsSearchResultItem', id: string, customerExternalId: string, displayName: string, alerts: Array<{ __typename?: 'CustomerAlert', dateOpened: string, obligorObligation: string, status: LoanStatus, repaymentFixAmount?: number | null, fixAmount?: number | null, loanId: string, alertStatus?: AlertStatus | null, deadline?: string | null } | null> } | null> | null } };

export type CustomerLoanApplicationActivitiesSearchQueryVariables = Exact<{
  fromIndex: Scalars['Int'];
  numResults: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
}>;


export type CustomerLoanApplicationActivitiesSearchQuery = { __typename?: 'Query', customerLoanApplicationActivitiesSearch: { __typename?: 'CustomerLoanApplicationActivitiesSearchResponse', totalHits: number, numResults: number, fromIndex: number, searchText?: string | null, items?: Array<{ __typename?: 'CustomerLoanApplicationActivitiesSearchResponseItem', id: string, customerExternalId: string, displayName: string, activities: Array<{ __typename?: 'CustomerActivity', description: string, referenceType: CustomerActivityType, referenceId: string, eventOccurredAt: string } | null> } | null> | null } };

export type CustomerEvaluationsQueryVariables = Exact<{
  customerID: Scalars['String'];
}>;


export type CustomerEvaluationsQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', customerId: string, evaluations?: Array<{ __typename?: 'Evaluation', id?: string | null, externalId: string, lastEvaluated?: string | null, customerId?: string | null, status?: EvaluationStatus | null } | null> | null } };

export type CustomerLoanApplicationActivitiesQueryVariables = Exact<{
  customerId: Scalars['ID'];
  applicationId: Scalars['ID'];
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
}>;


export type CustomerLoanApplicationActivitiesQuery = { __typename?: 'Query', customerLoanApplicationActivities?: { __typename?: 'CustomerLoanApplicationActivities', activities: Array<{ __typename?: 'CustomerActivity', description: string, referenceType: CustomerActivityType, referenceId: string, eventOccurredAt: string } | null> } | null };

export type AccountListQueryVariables = Exact<{
  customerId: Scalars['String'];
}>;


export type AccountListQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, customerId: string, displayName: string, serviceStatus?: { __typename?: 'ServiceStatus', status?: LoanStatus | null } | null, collateralAccounts?: Array<{ __typename?: 'CollateralAccount', id: string, collateralAccountId: string, accountType?: string | null, custodian?: string | null, ineligible?: boolean | null, source?: AccountSource | null, pledged?: boolean | null, ownerId?: string | null, ownerDisplayName?: string | null, marketData?: { __typename?: 'CollateralMarketData', marketValue?: number | null } | null } | null> | null } };

export type ParseAssetCsvQueryVariables = Exact<{
  csv: Scalars['String'];
  systemAccountIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ParseAssetCsvQuery = { __typename?: 'Query', parseAssetCSV?: { __typename?: 'ParsedAssetsCSV', records: Array<{ __typename?: 'ParsedAccount', errors?: Array<ParsedAssetError> | null, account?: { __typename?: 'CollateralAccount', id: string, collateralAccountId: string, accountType?: string | null, custodian?: string | null, currency?: string | null, pledged?: boolean | null, source?: AccountSource | null, ownerId?: string | null, assetHoldings?: Array<{ __typename?: 'AssetHolding', securityId: string, quantity: number, assetType: string } | null> | null } | null }> } | null };

export type AttachEvaluationPdfMutationVariables = Exact<{
  formBundleId: Scalars['String'];
}>;


export type AttachEvaluationPdfMutation = { __typename?: 'Mutation', attachEvaluationPdf: string };

export type GetEvaluationQueryVariables = Exact<{
  evaluationId: Scalars['String'];
}>;


export type GetEvaluationQuery = { __typename?: 'Query', evaluation?: { __typename?: 'Evaluation', id?: string | null, commitmentAmount?: number | null, topupThreshold?: number | null, selloutThreshold?: number | null, lastEvaluated?: string | null, status?: EvaluationStatus | null, externalId: string, label?: string | null, compareTo?: string | null, description?: string | null, creditPolicyId?: string | null, customerExternalId?: string | null, evaluationCollateralAccount: Array<{ __typename?: 'EvaluationCollateralAccount', accountType?: string | null, collateralAccountId?: string | null, custodian?: string | null, externalAccountId: string, id: string, lastUpdateDate?: string | null, marketValue?: number | null, ownerDisplayName?: string | null, ownerId?: string | null, source?: AccountSource | null, pledged?: boolean | null, evaluationAssets?: Array<{ __typename?: 'EvaluationCollateralAsset', assetId: string, quantity: number, type: string, currency: Currency } | null> | null }>, evaluationAssetSummary: Array<{ __typename?: 'EvaluationAssetSummary', id?: string | null, assetType: string, advanceRate: number, marketValue: number, collateralValue: number }> } | null };

export type RunEvaluationQueryVariables = Exact<{
  runEvaluation: RunEvaluationInput;
}>;


export type RunEvaluationQuery = { __typename?: 'Query', runEvaluation: { __typename?: 'EvaluationToBeSaved', id?: string | null, externalId: string, commitmentAmount?: number | null, topupThreshold?: number | null, selloutThreshold?: number | null, creditPolicyId?: string | null, evaluationAssetSummary: Array<{ __typename?: 'EvaluationAssetSummary', assetType: string, marketValue: number, collateralValue: number, advanceRate: number, id?: string | null }> } };

export type StartApplicationMutationVariables = Exact<{
  application: ApplicationInput;
}>;


export type StartApplicationMutation = { __typename?: 'Mutation', saveApplication: { __typename?: 'ApplicationSavedResponse', formBundleId: string } };

export type SaveEvaluationMutationVariables = Exact<{
  evaluation: EvaluationInput;
  evaluationDate: Scalars['String'];
}>;


export type SaveEvaluationMutation = { __typename?: 'Mutation', saveEvaluation: { __typename?: 'EvaluationToBeSaved', id?: string | null, externalId: string, commitmentAmount?: number | null, topupThreshold?: number | null, selloutThreshold?: number | null, creditPolicyId?: string | null, evaluationAssetSummary: Array<{ __typename?: 'EvaluationAssetSummary', assetType: string, marketValue: number, collateralValue: number, advanceRate: number, id?: string | null }> } };

export type UnpledgedAccountsQueryVariables = Exact<{
  customerId: Scalars['String'];
  systemAccountIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UnpledgedAccountsQuery = { __typename?: 'Query', unpledgedAccounts?: { __typename?: 'ValidatedCollateralAccounts', warning?: string | null, records: Array<{ __typename?: 'ParsedAccount', errors?: Array<ParsedAssetError> | null, account?: { __typename?: 'CollateralAccount', id: string, collateralAccountId: string, accountType?: string | null, custodian?: string | null, currency?: string | null, pledged?: boolean | null, source?: AccountSource | null, ownerId?: string | null, ownerDisplayName?: string | null, assetHoldings?: Array<{ __typename?: 'AssetHolding', securityId: string, quantity: number, assetType: string } | null> | null } | null }> } | null };

export type UnpledgedAccountsManyCustomersQueryVariables = Exact<{
  customerIds: Array<Scalars['String']> | Scalars['String'];
  systemAccountIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UnpledgedAccountsManyCustomersQuery = { __typename?: 'Query', unpledgedAccountsManyCustomers?: { __typename?: 'ValidatedCollateralAccounts', warning?: string | null, records: Array<{ __typename?: 'ParsedAccount', errors?: Array<ParsedAssetError> | null, account?: { __typename?: 'CollateralAccount', id: string, collateralAccountId: string, accountType?: string | null, custodian?: string | null, currency?: string | null, pledged?: boolean | null, source?: AccountSource | null, ownerId?: string | null, assetHoldings?: Array<{ __typename?: 'AssetHolding', securityId: string, quantity: number, assetType: string } | null> | null } | null }> } | null };

export type AlertsSummaryQueryVariables = Exact<{
  dataBarrierFunctionality?: InputMaybe<DataBarrierFunctionality>;
}>;


export type AlertsSummaryQuery = { __typename?: 'Query', alertsSummary: Array<{ __typename?: 'AlertSummary', status: LoanStatus, count: number } | null> };

export type LoanCommentsQueryVariables = Exact<{
  loanId: Scalars['String'];
}>;


export type LoanCommentsQuery = { __typename?: 'Query', loanComments: Array<{ __typename?: 'LoanComment', text: string, date: string } | null> };

export type LoanSummaryQueryVariables = Exact<{
  customerID: Scalars['String'];
}>;


export type LoanSummaryQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', customerId: string, weightedInterestRate?: number | null, serviceStatus?: { __typename?: 'ServiceStatus', priority?: number | null, status?: LoanStatus | null, severity?: number | null } | null, opportunity?: { __typename?: 'Opportunity', lendableAmount?: number | null, potentialToBorrow?: number | null, totalRemainingMarketValue?: number | null, totalRemainingEligibleMarketValue?: number | null } | null, pledgedAccountSummary?: { __typename?: 'PledgedAccountSummary', totalMarketValue?: number | null, totalEligibleMarketValue?: number | null, totalCollateralValue?: number | null } | null, portfolioSummary?: { __typename?: 'PortfolioSummary', numberOfLoans?: number | null, utilizationRate?: number | null, totalCommitment?: number | null, totalOutstandingBalance?: number | null, availability?: number | null } | null, loans?: Array<{ __typename?: 'Loan', id: string, obligor?: string | null, obligation?: string | null, status?: LoanStatus | null, commitmentAmount?: number | null, outstandingBalance?: number | null, isCrossCollateralised?: boolean | null, loanCollateral?: Array<{ __typename?: 'LoanCollateral', accountId: string, collateralAccountId: string } | null> | null } | null> | null, collateralAccounts?: Array<{ __typename?: 'CollateralAccount', id: string } | null> | null } };

export type PartiesQueryVariables = Exact<{
  loanID: Scalars['String'];
}>;


export type PartiesQuery = { __typename?: 'Query', loanParties: Array<{ __typename?: 'Party', id: string, relationship: PartyRelationship, displayName: string, customerExternalId: string, governmentFederalTaxId?: string | null, type?: string | null, govId?: string | null, collateralAccounts?: Array<{ __typename?: 'AccountOwnerAccount', collateralAccountId: string } | null> | null } | null> };

export type SingleLoanQueryVariables = Exact<{
  loanID: Scalars['String'];
  customerID: Scalars['String'];
}>;


export type SingleLoanQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', displayName: string, customerId: string, opportunity?: { __typename?: 'Opportunity', lendableAmount?: number | null, potentialToBorrow?: number | null } | null, portfolioSummary?: { __typename?: 'PortfolioSummary', numberOfLoans?: number | null } | null, collateralAccounts?: Array<{ __typename?: 'CollateralAccount', id: string } | null> | null }, loan?: { __typename?: 'Loan', id: string, status?: LoanStatus | null, obligor?: string | null, obligation?: string | null, startDate?: string | null, endDate?: string | null, productType?: string | null, minimumBalance?: number | null, commitmentAmount?: number | null, outstandingBalance?: number | null, compareTo?: CompareTo | null, marketValue?: number | null, eligibleMarketValue?: number | null, selloutThreshold?: number | null, topupThreshold?: number | null, collateralValue?: number | null, currentInterestRate?: number | null, rateType?: RateType | null, rateIndex?: string | null, spread?: number | null, floorRate?: number | null, paymentAmount?: number | null, nextPaymentDueDate?: string | null, remainingCollateralValue?: number | null, remainingMarketValue?: number | null, remainingEligibleMarketValue?: number | null, repaymentFixAmount?: number | null, fixAmount?: number | null, topUpCushion?: number | null, isCrossCollateralised?: boolean | null, availability?: number | null, utilizationRate?: number | null, blendedAdvanceRate?: number | null, blendedTopUpRate?: number | null, blendedSellOutRate?: number | null, accountNumber?: string | null, ytdInterestPaid?: number | null, interestSinceInception?: number | null, dailyInterest?: number | null, mtdInterest?: number | null, priorYearInterest?: number | null, autoRenewable?: boolean | null, loanCollateral?: Array<{ __typename?: 'LoanCollateral', accountId: string, collateralAccountId: string } | null> | null } | null };

export type LoanProposalQueryVariables = Exact<{
  evaluationId: Scalars['String'];
}>;


export type LoanProposalQuery = { __typename?: 'Query', evaluation?: { __typename?: 'Evaluation', id?: string | null, commitmentAmount?: number | null, customerExternalId?: string | null } | null, applicationConfig: { __typename?: 'ApplicationConfig', loanProposal: { __typename?: 'LoanProposalConfig', minimumLoanAmount?: number | null, minimumLoanAmountWarning?: number | null, applicationSubmittedMsg: string, showFields: { __typename?: 'LoanProposalShowFields', loanAmount: boolean, loanPurpose: boolean, primaryLoanPurpose: boolean, productType: boolean, loanType: boolean, loanTerm: boolean, interestRateType: boolean, proposedPricing: boolean, borrowerType: boolean, floor: boolean, fees: boolean, initialRate: boolean, exceptionRequest: boolean, exceptionRequestRationale: boolean, spread: boolean }, fieldsOptions: { __typename?: 'LoanProposalFieldsOptions', interestRateDefaultValue?: string | null, spread?: number | null, loanPurpose: { __typename?: 'LoanProposalFieldOptions', other: boolean, options: Array<string>, defaultValue?: string | null }, primaryLoanPurpose?: { __typename?: 'LoanProposalFieldOptions', options: Array<string>, defaultValue?: string | null } | null, productType?: { __typename?: 'LoanProposalFieldOptions', options: Array<string>, defaultValue?: string | null } | null, loanType: { __typename?: 'LoanProposalFieldOptions', options: Array<string>, defaultValue?: string | null }, loanTerm: { __typename?: 'LoanProposalFieldOptions', other: boolean, options: Array<string> }, loanIndex: { __typename?: 'LoanProposalFixedVariableField', fixed?: Array<string> | null, variable?: Array<string> | null, defaultValue?: string | null }, interestRateMarginShow: { __typename?: 'FixedVariableShow', fixed: boolean, variable: boolean }, floorShow: { __typename?: 'FixedVariableShow', fixed: boolean, variable: boolean }, fixedRatePeriod: { __typename?: 'FixedRatePeriod', termOtherShow: boolean, fixedRatePeriodTerm?: Array<string> | null, initialRateShow: boolean, feesShow: boolean }, borrowerType: { __typename?: 'LoanProposalFieldOptions', options: Array<string>, defaultValue?: string | null }, exceptionRequest: { __typename?: 'LoanProposalFieldOptions', options: Array<string>, defaultValue?: string | null } }, rates: Array<{ __typename?: 'LoanProposalRates', from?: number | null, to?: number | null, loanType: string, loanTerm?: string | null, interestRateType: RateType, loanIndex?: string | null, rates: string, spread?: number | null }> } } };

export type ApplicationsListQueryVariables = Exact<{
  fromIndex: Scalars['Int'];
  numResults: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Array<ApplicationSearchSortByInput> | ApplicationSearchSortByInput>;
}>;


export type ApplicationsListQuery = { __typename?: 'Query', applicationsSearch: { __typename?: 'ApplicationSearchResponse', numResults: number, totalHits: number, items?: Array<{ __typename?: 'ApplicationSearchResultItem', id: string, requestedLoanAmount?: number | null, lastUpdateDate: string, customerName: string, customerExternalId: string, customerId: string, status: ApplicationStatus, formBundleId: string } | null> | null } };

export type EvaluationsListQueryVariables = Exact<{
  fromIndex: Scalars['Int'];
  numResults: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Array<EvaluationSearchSortByInput> | EvaluationSearchSortByInput>;
}>;


export type EvaluationsListQuery = { __typename?: 'Query', evaluationsSearch: { __typename?: 'EvaluationSearchResponse', numResults: number, totalHits: number, items?: Array<{ __typename?: 'EvaluationSearchResultItem', id: string, commitmentAmount?: number | null, lastEvaluated: string, customerName: string, customerExternalId: string, customerId: string, status: EvaluationStatus, externalId: string } | null> | null } };

export type PermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionQuery = { __typename?: 'Query', userPermissions: { __typename?: 'UserPermissions', canViewCustomers?: boolean | null, canViewLoans?: boolean | null, canAccessLoanPdf?: boolean | null, canViewCollateralAccounts?: boolean | null, canViewInternalContacts?: boolean | null, canPerformReleaseRequest?: boolean | null, canPerformDrawdownRequest?: boolean | null, canViewEvaluations?: boolean | null, canCreateModifyRunEvaluations?: boolean | null, canAccessEvaluationPdf?: boolean | null, canCreateLoanApplication?: boolean | null, canAcquireAccountHeldAway?: boolean | null, canAddAccountManually?: boolean | null, canViewApplications?: boolean | null, canViewActivityNotifications?: boolean | null, canDownloadLoanDocs?: boolean | null } };


export const AuditReportDocument = `
    mutation auditReport($activityType: ActivityAuditType!, $resourceAccessed: String, $customerExternalId: String, $queryDetails: String) {
  triggerActivityAudit(
    activityType: $activityType
    resourceAccessed: $resourceAccessed
    customerExternalId: $customerExternalId
    queryDetails: $queryDetails
  )
}
    `;
export const useAuditReportMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AuditReportMutation, TError, AuditReportMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AuditReportMutation, TError, AuditReportMutationVariables, TContext>(
      ['auditReport'],
      (variables?: AuditReportMutationVariables) => fetcher<AuditReportMutation, AuditReportMutationVariables>(client, AuditReportDocument, variables, headers)(),
      options
    );
useAuditReportMutation.getKey = () => ['auditReport'];

export const DatafeedDocument = `
    query datafeed {
  datafeed {
    updated
  }
}
    `;
export const useDatafeedQuery = <
      TData = DatafeedQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: DatafeedQueryVariables,
      options?: UseQueryOptions<DatafeedQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<DatafeedQuery, TError, TData>(
      variables === undefined ? ['datafeed'] : ['datafeed', variables],
      fetcher<DatafeedQuery, DatafeedQueryVariables>(client, DatafeedDocument, variables, headers),
      options
    );
useDatafeedQuery.document = DatafeedDocument;


useDatafeedQuery.getKey = (variables?: DatafeedQueryVariables) => variables === undefined ? ['datafeed'] : ['datafeed', variables];
;

export const CreditPoliciesDocument = `
    query creditPolicies {
  creditPolicies {
    id
    description {
      value
    }
  }
}
    `;
export const useCreditPoliciesQuery = <
      TData = CreditPoliciesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CreditPoliciesQueryVariables,
      options?: UseQueryOptions<CreditPoliciesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CreditPoliciesQuery, TError, TData>(
      variables === undefined ? ['creditPolicies'] : ['creditPolicies', variables],
      fetcher<CreditPoliciesQuery, CreditPoliciesQueryVariables>(client, CreditPoliciesDocument, variables, headers),
      options
    );
useCreditPoliciesQuery.document = CreditPoliciesDocument;


useCreditPoliciesQuery.getKey = (variables?: CreditPoliciesQueryVariables) => variables === undefined ? ['creditPolicies'] : ['creditPolicies', variables];
;

export const CollateralAccountsDocument = `
    query collateralAccounts($customerID: String!) {
  customer(customerId: $customerID) {
    customerId
    collateralAccounts {
      id
      collateralAccountId
      secondaryCollateralAccountIds {
        secondaryCollateralId
      }
      accountType
      custodian
      pledged
      ineligible
      totalApportioned
      marketData {
        marketValue
        eligibleMarketValue
        collateralValue
      }
      assetTotal(customerId: $customerID) {
        assetSubType
        assetSubTypeDetails
        marketValue
        eligible
      }
      loanCollateral {
        loanId
        obligor
        obligation
        apportionedAmount
      }
    }
  }
}
    `;
export const useCollateralAccountsQuery = <
      TData = CollateralAccountsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CollateralAccountsQueryVariables,
      options?: UseQueryOptions<CollateralAccountsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CollateralAccountsQuery, TError, TData>(
      ['collateralAccounts', variables],
      fetcher<CollateralAccountsQuery, CollateralAccountsQueryVariables>(client, CollateralAccountsDocument, variables, headers),
      options
    );
useCollateralAccountsQuery.document = CollateralAccountsDocument;


useCollateralAccountsQuery.getKey = (variables: CollateralAccountsQueryVariables) => ['collateralAccounts', variables];
;

export const CustomerDetailsDocument = `
    query customerDetails($customerID: String!) {
  customer(customerId: $customerID) {
    id
    displayName
    customerId
    firstName
    lastName
    title
    middleName
    middleInitial
    email
    phone
    addressLine1
    addressLine2
    city
    state
    zip
    dateOfBirth
    govId
    type
    governmentFederalTaxId
    metadata {
      fieldType
      fieldName
      fieldValue
    }
  }
}
    `;
export const useCustomerDetailsQuery = <
      TData = CustomerDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomerDetailsQueryVariables,
      options?: UseQueryOptions<CustomerDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerDetailsQuery, TError, TData>(
      ['customerDetails', variables],
      fetcher<CustomerDetailsQuery, CustomerDetailsQueryVariables>(client, CustomerDetailsDocument, variables, headers),
      options
    );
useCustomerDetailsQuery.document = CustomerDetailsDocument;


useCustomerDetailsQuery.getKey = (variables: CustomerDetailsQueryVariables) => ['customerDetails', variables];
;

export const CustomerHeaderDocument = `
    query customerHeader($customerID: String!) {
  customer(customerId: $customerID) {
    id
    customerId
    displayName
    serviceStatus {
      priority
      status
    }
    lastUpdateDate
  }
}
    `;
export const useCustomerHeaderQuery = <
      TData = CustomerHeaderQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomerHeaderQueryVariables,
      options?: UseQueryOptions<CustomerHeaderQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerHeaderQuery, TError, TData>(
      ['customerHeader', variables],
      fetcher<CustomerHeaderQuery, CustomerHeaderQueryVariables>(client, CustomerHeaderDocument, variables, headers),
      options
    );
useCustomerHeaderQuery.document = CustomerHeaderDocument;


useCustomerHeaderQuery.getKey = (variables: CustomerHeaderQueryVariables) => ['customerHeader', variables];
;

export const CustomerLoansDocument = `
    query customerLoans($customerID: String!) {
  customer(customerId: $customerID) {
    customerId
    displayName
    loans {
      id
      obligor
      obligation
    }
  }
}
    `;
export const useCustomerLoansQuery = <
      TData = CustomerLoansQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomerLoansQueryVariables,
      options?: UseQueryOptions<CustomerLoansQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerLoansQuery, TError, TData>(
      ['customerLoans', variables],
      fetcher<CustomerLoansQuery, CustomerLoansQueryVariables>(client, CustomerLoansDocument, variables, headers),
      options
    );
useCustomerLoansQuery.document = CustomerLoansDocument;


useCustomerLoansQuery.getKey = (variables: CustomerLoansQueryVariables) => ['customerLoans', variables];
;

export const CustomersListDocument = `
    query customersList($fromIndex: Int!, $numResults: Int!, $sortBy: [CustomerSearchSortByInput]) {
  customersList(
    searchInput: {numResults: $numResults, fromIndex: $fromIndex, sortBy: $sortBy}
  ) {
    items {
      id
      displayName
      customerId
      email
      phone
      govId
      interestRate
      obligors
      numberOfLoans
      governmentFederalTaxId
      collateralAccountIds
      serviceStatus
      totalCollateralValue
      totalCommitments
      totalMarketValue
      totalOutstandingBalance
      availability
    }
    numResults
    lastSearchIndex
    totalHits
  }
}
    `;
export const useCustomersListQuery = <
      TData = CustomersListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomersListQueryVariables,
      options?: UseQueryOptions<CustomersListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomersListQuery, TError, TData>(
      ['customersList', variables],
      fetcher<CustomersListQuery, CustomersListQueryVariables>(client, CustomersListDocument, variables, headers),
      options
    );
useCustomersListQuery.document = CustomersListDocument;


useCustomersListQuery.getKey = (variables: CustomersListQueryVariables) => ['customersList', variables];
;

export const CustomersSearchDocument = `
    query customersSearch($fromIndex: Int!, $numResults: Int!, $searchText: String, $sortBy: [CustomerSearchSortByInput]) {
  customersSearch(
    searchInput: {numResults: $numResults, fromIndex: $fromIndex, searchText: $searchText, sortBy: $sortBy}
  ) {
    items {
      id
      displayName
      customerId
      email
      phone
      govId
      interestRate
      obligors
      numberOfLoans
      governmentFederalTaxId
      collateralAccountIds
      serviceStatus
      totalCollateralValue
      totalCommitments
      totalMarketValue
      totalOutstandingBalance
      availability
    }
    numResults
    lastSearchIndex
    totalHits
  }
}
    `;
export const useCustomersSearchQuery = <
      TData = CustomersSearchQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomersSearchQueryVariables,
      options?: UseQueryOptions<CustomersSearchQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomersSearchQuery, TError, TData>(
      ['customersSearch', variables],
      fetcher<CustomersSearchQuery, CustomersSearchQueryVariables>(client, CustomersSearchDocument, variables, headers),
      options
    );
useCustomersSearchQuery.document = CustomersSearchDocument;


useCustomersSearchQuery.getKey = (variables: CustomersSearchQueryVariables) => ['customersSearch', variables];
;

export const InternalContactsDocument = `
    query internalContacts($customerID: String!) {
  customer(customerId: $customerID) {
    customerId
    internalContacts {
      id
      name
      role
      phone
      email
    }
  }
}
    `;
export const useInternalContactsQuery = <
      TData = InternalContactsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: InternalContactsQueryVariables,
      options?: UseQueryOptions<InternalContactsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<InternalContactsQuery, TError, TData>(
      ['internalContacts', variables],
      fetcher<InternalContactsQuery, InternalContactsQueryVariables>(client, InternalContactsDocument, variables, headers),
      options
    );
useInternalContactsQuery.document = InternalContactsDocument;


useInternalContactsQuery.getKey = (variables: InternalContactsQueryVariables) => ['internalContacts', variables];
;

export const CustomisationDocument = `
    query customisation {
  applicationConfig {
    theme {
      owner
      colorSchema {
        secondaryBg
        primaryBg
        primaryText
        secondaryText
        disabled
        primary {
          _700
          _600
          _500
          _400
          _300
          _200
          _100
          _50
        }
        secondary {
          _700
          _600
          _500
          _400
          _300
          _200
          _100
          _50
        }
        gray {
          _700
          _600
          _500
          _400
          _300
          _200
          _100
          _50
        }
        green {
          _700
          _600
          _500
          _400
          _300
          _200
          _100
          _50
        }
        red {
          _700
          _600
          _500
          _400
          _300
          _200
          _100
          _50
        }
        pink {
          _700
          _600
          _500
          _400
          _300
          _200
          _100
          _50
        }
        purple {
          _700
          _600
          _500
          _400
          _300
          _200
          _100
          _50
        }
        indigo {
          _700
          _600
          _500
          _400
          _300
          _200
          _100
          _50
        }
        cyan {
          _700
          _600
          _500
          _400
          _300
          _200
          _100
          _50
        }
        lime {
          _700
          _600
          _500
          _400
          _300
          _200
          _100
          _50
        }
        yellow {
          _700
          _600
          _500
          _400
          _300
          _200
          _100
          _50
        }
        orange {
          _700
          _600
          _500
          _400
          _300
          _200
          _100
          _50
        }
      }
    }
    sideMenu {
      home {
        navKey
        show
      }
      customers {
        navKey
        show
      }
      originations {
        navKey
        show
      }
      reports {
        navKey
        show
      }
    }
    partiesV2 {
      show
      sections {
        show
        type
        fields {
          type
          values {
            fieldName
            show
          }
        }
      }
    }
    labels {
      accountNumber
      accountOwnerDetails
      accountType
      accounts
      acquireUnpledgedAccounts
      actions
      addAccountsEvaluation
      addAccountsInfo
      address
      addThirdParty
      applications
      applyForALoan
      applyForLoanInfo
      apportionedAmounts
      assetType
      autoRenewable
      availability
      backToSummary
      blendedAdvanceRate
      blendedRates
      blendedSellOutRate
      blendedTopUpRate
      borrower
      borrowerDetails
      borrowerType
      cash
      chooseAccounts
      chooseCreditPolicy
      chooseCustomer
      city
      coBorrowers
      collateralAccountId
      collateralAccountNumbers
      collateralAccountNumber
      collateralValue
      commitmentAmount
      compareTo
      creditPolicy
      currentInterestRate
      custodian
      customerDetails
      customer
      customers
      customerId
      customerProfile
      customersTableId
      dailyInterest
      date
      dateOfBirth
      details
      downloadDocument
      downloadPdf
      eligibleForSBL
      eligibleMarketValue
      email
      endDate
      equity
      etfs
      evaluateInfo
      evaluations
      exceptionRequest
      exceptionRequestPlaceholder
      extraInformation
      fees
      firstName
      fixedIncome
      floor
      floorRate
      govId
      governmentFederalTaxId
      graphCannotBeDisplayed
      guarantors
      home
      household
      id
      importAccountWithHoldings
      ineligibles
      initialRate
      interestHistory
      interestPayments
      interestRate
      interestRates
      interestRateType
      interestSinceInception
      internalContactDetails
      internalContacts
      keyInformation
      lastName
      legalEntityName
      legalEntityRegisteredAddress
      legalEntityType
      lendableAmount
      loan
      loanAmount
      loanDetails
      loanNumber
      loanObligation
      loanObligor
      loanOrigination
      loanParties
      loanProposal
      loanProposalType
      loanPurpose
      loanStatus
      loanTerm
      loanType
      loans
      marginAnalysis
      marketValue
      maxCommitmentAmount
      middleInitial
      middleName
      minimumBalance
      mtdInterest
      mutualFunds
      name
      newEvaluation
      noActiveAccounts
      noContacts
      numberOfLoans
      opportunity
      originations
      otherLoanPurpose
      outstandingBalance
      owner
      partiesInvolved
      paymentAmount
      paymentDueDate
      phone
      pledged
      pledgedAccounts
      pledgedAccountsSummary
      portfolioSummary
      potentialToBorrow
      primaryLoanPurpose
      productType
      priorYearInterest
      proposedPricing
      rate
      rateIndex
      rateType
      reEvaluate
      reEvaluateInfo
      remainingCollateralValue
      remainingEligibleMarketValue
      remainingMarketValue
      reports
      reviewYourSelection
      role
      secondaryCollateralAccountId
      securityId
      seeMore
      seeProfile
      selectAccountsCollateralGraph
      selectManualAccounts
      sellOutThreshold
      serviceStatus
      source
      spread
      ssn
      startApplication
      startDate
      state
      status
      taxId
      title
      topUpCushion
      topUpThreshold
      totalApportioned
      totalCollateralValue
      totalCollateralView
      totalCommitment
      totalEligibleMarketValue
      totalMarketValue
      totalOutstandingBalance
      totalRemainingEligibleMarketValue
      totalRemainingMarketValue
      units
      utilization
      view
      viewFullCustomerProfile
      weightedInterestRate
      ytdInterestPaid
      zip
    }
    loanDetailsInfo {
      show
      showFields {
        autoRenewable
        loanStatus
        loanObligor
        loanObligation
        loanType
        startDate
        endDate
      }
    }
    loanKeyInformation {
      show
      showFields {
        utilization
        availability
        commitmentAmount
        outstandingBalance
        compareTo
        minimumBalance
      }
    }
    loanInterestRates {
      show
      showFields {
        currentInterestRate
        rateType
        rateIndex
        spread
        floorRate
      }
    }
    loanInterestPayments {
      show
      showFields {
        paymentDueDate
        paymentAmount
        accountNumber
      }
    }
    loanInterestHistory {
      show
      showFields {
        interestSinceInception
        dailyInterest
        mtdInterest
        priorYearInterest
        ytdInterestPaid
      }
    }
    loanPledgedAccounts {
      show
      showFields {
        marketValue
        eligibleMarketValue
        collateralValue
        remainingMarketValue
        remainingEligibleMarketValue
        remainingCollateralValue
        pledgedAccounts
      }
    }
    loanOpportunity {
      show
      showFields {
        lendableAmount
        potentialToBorrow
      }
    }
    portfolioSummary {
      show
      showFields {
        numberOfLoans
        utilization
        totalCommitment
        totalOutstandingBalance
        availability
        weightedInterestRate
      }
    }
    portfolioOpportinity {
      show
      showFields {
        lendableAmount
        potentialToBorrow
        totalRemainingMarketValue
        totalRemainingEligibleMarketValue
      }
    }
    pledgedAccountsSummary {
      show
      showFields {
        totalMarketValue
        totalEligibleMarketValue
        totalCollateralValue
      }
    }
    loanAccounts {
      show
      showFields {
        loanNumber
        loanStatus
        commitmentAmount
        outstandingBalance
        pledgedAccounts
      }
    }
    loanBlendedRates {
      show
      showFields {
        blendedAdvanceRate
        blendedTopUpRate
        blendedSellOutRate
      }
    }
    loanMarginAnalysis {
      show
      showFields {
        eligibleMarketValue
        maxCommitmentAmount
        sellOutThreshold
        topUpThreshold
        topUpCushion
      }
    }
    customerList {
      customerId {
        show
        width
      }
      customer {
        show
        width
      }
      email {
        show
        width
      }
      phone {
        show
        width
      }
      totalCollateralValue {
        show
        width
      }
      totalMarketValue {
        show
        width
      }
      numberOfLoans {
        show
        width
      }
      totalCommitmentAmount {
        show
        width
      }
      totalOutstandingBalance {
        show
        width
      }
      interestRate {
        show
        width
      }
      availability {
        show
        width
      }
      serviceStatus {
        show
        width
      }
    }
    applicationsList {
      showFields {
        customerName
        formBundleId
        lastUpdateDate
        requestedLoanAmount
        status
        actions
      }
    }
    evaluationsList {
      showFields {
        customerName
        externalId
        lastEvaluated
        commitmentAmount
        status
        actions
      }
    }
    applicationsActionModal {
      showFields {
        view
        downloadDocument
      }
    }
    evaluationsActionModal {
      showFields {
        view
        reEvaluate
        startApplication
        downloadPdf
      }
    }
    collateralAccounts {
      showFields {
        collateralAccountId
        secondaryCollateralAccountId
        accountType
        custodian
        marketValue
        eligibleMarketValue
        collateralValue
        totalApportioned
        pledged
        apportionedAmounts
      }
    }
    customerDetailsV2 {
      showFields {
        name
        firstName
        lastName
        title
        middleName
        middleInitial
        email
        phone
        city
        state
        zip
        dateOfBirth
        address
        govId
        legalEntityType
        legalEntityName
        legalEntityRegisteredAddress
        governmentFederalTaxId
        extraInformation
      }
    }
    internalContacts {
      showFields {
        name
        role
        email
        phone
      }
    }
    dashboard {
      sections {
        id
        label
        show
        cards {
          customersActivity {
            label
            show
          }
          loanApplicationActivityStatus {
            label
            show
          }
          alerts {
            label
            show
          }
          alertsToLoanRatio {
            label
            show
          }
          lendingOpportunities {
            label
            show
          }
          topClients {
            label
            show
          }
          customer {
            label
            show
          }
          loans {
            label
            show
          }
          balances {
            label
            show
          }
          sblInterestRates {
            label
            show
          }
          sofrRates {
            label
            show
          }
          holdingWatchlist {
            label
            show
          }
          stockNews {
            label
            show
          }
        }
      }
    }
    evaluation {
      compareTo
      showButtons {
        acquireUnpledgedAccounts
        importAccountWithHoldings
        addAccounts
        addCustomerAccounts
        addThirdPartyAccounts
        importViaCSV
      }
    }
    customerHeader {
      showButtons {
        releaseCollateral
        requestDrawdown
      }
    }
    helpText {
      serviceStatus {
        sellOut
        topUp
        overAdvanced
        dataIssue
      }
      collateralValue
      endDate
      blendedAdvanceRate
      blendedTopUpRate
      blendedSellOutRate
      paymentDueDate
      paymentAmount
      noInvoice
      commitmentAmount
      totalCommitmentAmount
      collateralAccountNumber
      accountType
      custodian
      marketValue
      owner
      maxCommitmentAmount
      topUpThreshold
      sellOutThreshold
      spread
      assetType
      rate
      evaluationId
      unusedAccountInfo
    }
    creditPolicy {
      allowCreditPolicySelection
    }
    landing {
      default
    }
  }
}
    `;
export const useCustomisationQuery = <
      TData = CustomisationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CustomisationQueryVariables,
      options?: UseQueryOptions<CustomisationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomisationQuery, TError, TData>(
      variables === undefined ? ['customisation'] : ['customisation', variables],
      fetcher<CustomisationQuery, CustomisationQueryVariables>(client, CustomisationDocument, variables, headers),
      options
    );
useCustomisationQuery.document = CustomisationDocument;


useCustomisationQuery.getKey = (variables?: CustomisationQueryVariables) => variables === undefined ? ['customisation'] : ['customisation', variables];
;

export const CustomerActivitiesByTypeDocument = `
    query customerActivitiesByType($customerId: ID!, $activityType: String!, $dataBarrierFunctionality: DataBarrierFunctionality) {
  customerActivitiesByType(
    customerId: $customerId
    activityType: $activityType
    dataBarrierFunctionality: $dataBarrierFunctionality
  ) {
    activities {
      id
      description
      referenceType
      referenceId
      eventOccurredAt
    }
  }
}
    `;
export const useCustomerActivitiesByTypeQuery = <
      TData = CustomerActivitiesByTypeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomerActivitiesByTypeQueryVariables,
      options?: UseQueryOptions<CustomerActivitiesByTypeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerActivitiesByTypeQuery, TError, TData>(
      ['customerActivitiesByType', variables],
      fetcher<CustomerActivitiesByTypeQuery, CustomerActivitiesByTypeQueryVariables>(client, CustomerActivitiesByTypeDocument, variables, headers),
      options
    );
useCustomerActivitiesByTypeQuery.document = CustomerActivitiesByTypeDocument;


useCustomerActivitiesByTypeQuery.getKey = (variables: CustomerActivitiesByTypeQueryVariables) => ['customerActivitiesByType', variables];
;

export const CustomerActivitySearchDocument = `
    query customerActivitySearch($fromIndex: Int!, $numResults: Int!, $searchText: String, $dataBarrierFunctionality: DataBarrierFunctionality) {
  customerActivitySearch(
    searchInput: {numResults: $numResults, fromIndex: $fromIndex, searchText: $searchText}
    dataBarrierFunctionality: $dataBarrierFunctionality
  ) {
    items {
      customerId
      customerExternalId
      customerName
      activitiesStats {
        evaluation
        loanApplication
        loan
      }
    }
    totalHits
    numResults
    fromIndex
    searchText
  }
}
    `;
export const useCustomerActivitySearchQuery = <
      TData = CustomerActivitySearchQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomerActivitySearchQueryVariables,
      options?: UseQueryOptions<CustomerActivitySearchQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerActivitySearchQuery, TError, TData>(
      ['customerActivitySearch', variables],
      fetcher<CustomerActivitySearchQuery, CustomerActivitySearchQueryVariables>(client, CustomerActivitySearchDocument, variables, headers),
      options
    );
useCustomerActivitySearchQuery.document = CustomerActivitySearchDocument;


useCustomerActivitySearchQuery.getKey = (variables: CustomerActivitySearchQueryVariables) => ['customerActivitySearch', variables];
;

export const CustomerAlertsSearchDocument = `
    query customerAlertsSearch($fromIndex: Int!, $numResults: Int!, $searchText: String, $dataBarrierFunctionality: DataBarrierFunctionality) {
  customerAlertsSearch(
    searchInput: {numResults: $numResults, fromIndex: $fromIndex, searchText: $searchText}
    dataBarrierFunctionality: $dataBarrierFunctionality
  ) {
    items {
      id
      customerExternalId
      displayName
      alerts {
        dateOpened
        obligorObligation
        status
        repaymentFixAmount
        fixAmount
        loanId
        alertStatus
        deadline
      }
    }
    totalHits
    numResults
    fromIndex
    searchText
  }
}
    `;
export const useCustomerAlertsSearchQuery = <
      TData = CustomerAlertsSearchQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomerAlertsSearchQueryVariables,
      options?: UseQueryOptions<CustomerAlertsSearchQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerAlertsSearchQuery, TError, TData>(
      ['customerAlertsSearch', variables],
      fetcher<CustomerAlertsSearchQuery, CustomerAlertsSearchQueryVariables>(client, CustomerAlertsSearchDocument, variables, headers),
      options
    );
useCustomerAlertsSearchQuery.document = CustomerAlertsSearchDocument;


useCustomerAlertsSearchQuery.getKey = (variables: CustomerAlertsSearchQueryVariables) => ['customerAlertsSearch', variables];
;

export const CustomerLoanApplicationActivitiesSearchDocument = `
    query customerLoanApplicationActivitiesSearch($fromIndex: Int!, $numResults: Int!, $searchText: String, $dataBarrierFunctionality: DataBarrierFunctionality) {
  customerLoanApplicationActivitiesSearch(
    searchInput: {numResults: $numResults, fromIndex: $fromIndex, searchText: $searchText}
    dataBarrierFunctionality: $dataBarrierFunctionality
  ) {
    items {
      id
      customerExternalId
      displayName
      activities {
        description
        referenceType
        referenceId
        eventOccurredAt
      }
    }
    totalHits
    numResults
    fromIndex
    searchText
  }
}
    `;
export const useCustomerLoanApplicationActivitiesSearchQuery = <
      TData = CustomerLoanApplicationActivitiesSearchQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomerLoanApplicationActivitiesSearchQueryVariables,
      options?: UseQueryOptions<CustomerLoanApplicationActivitiesSearchQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerLoanApplicationActivitiesSearchQuery, TError, TData>(
      ['customerLoanApplicationActivitiesSearch', variables],
      fetcher<CustomerLoanApplicationActivitiesSearchQuery, CustomerLoanApplicationActivitiesSearchQueryVariables>(client, CustomerLoanApplicationActivitiesSearchDocument, variables, headers),
      options
    );
useCustomerLoanApplicationActivitiesSearchQuery.document = CustomerLoanApplicationActivitiesSearchDocument;


useCustomerLoanApplicationActivitiesSearchQuery.getKey = (variables: CustomerLoanApplicationActivitiesSearchQueryVariables) => ['customerLoanApplicationActivitiesSearch', variables];
;

export const CustomerEvaluationsDocument = `
    query customerEvaluations($customerID: String!) {
  customer(customerId: $customerID) {
    customerId
    evaluations {
      id
      externalId
      lastEvaluated
      customerId
      status
    }
  }
}
    `;
export const useCustomerEvaluationsQuery = <
      TData = CustomerEvaluationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomerEvaluationsQueryVariables,
      options?: UseQueryOptions<CustomerEvaluationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerEvaluationsQuery, TError, TData>(
      ['customerEvaluations', variables],
      fetcher<CustomerEvaluationsQuery, CustomerEvaluationsQueryVariables>(client, CustomerEvaluationsDocument, variables, headers),
      options
    );
useCustomerEvaluationsQuery.document = CustomerEvaluationsDocument;


useCustomerEvaluationsQuery.getKey = (variables: CustomerEvaluationsQueryVariables) => ['customerEvaluations', variables];
;

export const CustomerLoanApplicationActivitiesDocument = `
    query customerLoanApplicationActivities($customerId: ID!, $applicationId: ID!, $dataBarrierFunctionality: DataBarrierFunctionality) {
  customerLoanApplicationActivities(
    customerId: $customerId
    applicationId: $applicationId
    dataBarrierFunctionality: $dataBarrierFunctionality
  ) {
    activities {
      description
      referenceType
      referenceId
      eventOccurredAt
    }
  }
}
    `;
export const useCustomerLoanApplicationActivitiesQuery = <
      TData = CustomerLoanApplicationActivitiesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomerLoanApplicationActivitiesQueryVariables,
      options?: UseQueryOptions<CustomerLoanApplicationActivitiesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerLoanApplicationActivitiesQuery, TError, TData>(
      ['customerLoanApplicationActivities', variables],
      fetcher<CustomerLoanApplicationActivitiesQuery, CustomerLoanApplicationActivitiesQueryVariables>(client, CustomerLoanApplicationActivitiesDocument, variables, headers),
      options
    );
useCustomerLoanApplicationActivitiesQuery.document = CustomerLoanApplicationActivitiesDocument;


useCustomerLoanApplicationActivitiesQuery.getKey = (variables: CustomerLoanApplicationActivitiesQueryVariables) => ['customerLoanApplicationActivities', variables];
;

export const AccountListDocument = `
    query accountList($customerId: String!) {
  customer(customerId: $customerId) {
    id
    customerId
    displayName
    serviceStatus {
      status
    }
    collateralAccounts {
      id
      collateralAccountId
      accountType
      custodian
      ineligible
      source
      pledged
      ownerId
      ownerDisplayName
      marketData {
        marketValue
      }
    }
  }
}
    `;
export const useAccountListQuery = <
      TData = AccountListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AccountListQueryVariables,
      options?: UseQueryOptions<AccountListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AccountListQuery, TError, TData>(
      ['accountList', variables],
      fetcher<AccountListQuery, AccountListQueryVariables>(client, AccountListDocument, variables, headers),
      options
    );
useAccountListQuery.document = AccountListDocument;


useAccountListQuery.getKey = (variables: AccountListQueryVariables) => ['accountList', variables];
;

export const ParseAssetCsvDocument = `
    query parseAssetCSV($csv: String!, $systemAccountIds: [String!]!) {
  parseAssetCSV(csv: $csv, systemAccountIds: $systemAccountIds) {
    records {
      account {
        id
        collateralAccountId
        accountType
        custodian
        currency
        pledged
        source
        ownerId
        assetHoldings {
          securityId
          quantity
          assetType
        }
      }
      errors
    }
  }
}
    `;
export const useParseAssetCsvQuery = <
      TData = ParseAssetCsvQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ParseAssetCsvQueryVariables,
      options?: UseQueryOptions<ParseAssetCsvQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ParseAssetCsvQuery, TError, TData>(
      ['parseAssetCSV', variables],
      fetcher<ParseAssetCsvQuery, ParseAssetCsvQueryVariables>(client, ParseAssetCsvDocument, variables, headers),
      options
    );
useParseAssetCsvQuery.document = ParseAssetCsvDocument;


useParseAssetCsvQuery.getKey = (variables: ParseAssetCsvQueryVariables) => ['parseAssetCSV', variables];
;

export const AttachEvaluationPdfDocument = `
    mutation attachEvaluationPdf($formBundleId: String!) {
  attachEvaluationPdf(formBundleId: $formBundleId)
}
    `;
export const useAttachEvaluationPdfMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AttachEvaluationPdfMutation, TError, AttachEvaluationPdfMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AttachEvaluationPdfMutation, TError, AttachEvaluationPdfMutationVariables, TContext>(
      ['attachEvaluationPdf'],
      (variables?: AttachEvaluationPdfMutationVariables) => fetcher<AttachEvaluationPdfMutation, AttachEvaluationPdfMutationVariables>(client, AttachEvaluationPdfDocument, variables, headers)(),
      options
    );
useAttachEvaluationPdfMutation.getKey = () => ['attachEvaluationPdf'];

export const GetEvaluationDocument = `
    query getEvaluation($evaluationId: String!) {
  evaluation(evaluationId: $evaluationId) {
    id
    evaluationCollateralAccount {
      accountType
      collateralAccountId
      custodian
      externalAccountId
      id
      lastUpdateDate
      marketValue
      ownerDisplayName
      ownerId
      source
      pledged
      evaluationAssets {
        assetId
        quantity
        type
        currency
      }
    }
    commitmentAmount
    topupThreshold
    selloutThreshold
    lastEvaluated
    status
    externalId
    label
    compareTo
    description
    creditPolicyId
    customerExternalId
    evaluationAssetSummary {
      id
      assetType
      advanceRate
      marketValue
      collateralValue
    }
  }
}
    `;
export const useGetEvaluationQuery = <
      TData = GetEvaluationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEvaluationQueryVariables,
      options?: UseQueryOptions<GetEvaluationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEvaluationQuery, TError, TData>(
      ['getEvaluation', variables],
      fetcher<GetEvaluationQuery, GetEvaluationQueryVariables>(client, GetEvaluationDocument, variables, headers),
      options
    );
useGetEvaluationQuery.document = GetEvaluationDocument;


useGetEvaluationQuery.getKey = (variables: GetEvaluationQueryVariables) => ['getEvaluation', variables];
;

export const RunEvaluationDocument = `
    query runEvaluation($runEvaluation: RunEvaluationInput!) {
  runEvaluation(runEvaluation: $runEvaluation) {
    id
    externalId
    commitmentAmount
    topupThreshold
    selloutThreshold
    creditPolicyId
    evaluationAssetSummary {
      assetType
      marketValue
      collateralValue
      advanceRate
      id
    }
  }
}
    `;
export const useRunEvaluationQuery = <
      TData = RunEvaluationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: RunEvaluationQueryVariables,
      options?: UseQueryOptions<RunEvaluationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<RunEvaluationQuery, TError, TData>(
      ['runEvaluation', variables],
      fetcher<RunEvaluationQuery, RunEvaluationQueryVariables>(client, RunEvaluationDocument, variables, headers),
      options
    );
useRunEvaluationQuery.document = RunEvaluationDocument;


useRunEvaluationQuery.getKey = (variables: RunEvaluationQueryVariables) => ['runEvaluation', variables];
;

export const StartApplicationDocument = `
    mutation startApplication($application: ApplicationInput!) {
  saveApplication(application: $application) {
    formBundleId
  }
}
    `;
export const useStartApplicationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<StartApplicationMutation, TError, StartApplicationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<StartApplicationMutation, TError, StartApplicationMutationVariables, TContext>(
      ['startApplication'],
      (variables?: StartApplicationMutationVariables) => fetcher<StartApplicationMutation, StartApplicationMutationVariables>(client, StartApplicationDocument, variables, headers)(),
      options
    );
useStartApplicationMutation.getKey = () => ['startApplication'];

export const SaveEvaluationDocument = `
    mutation saveEvaluation($evaluation: EvaluationInput!, $evaluationDate: String!) {
  saveEvaluation(evaluation: $evaluation, evaluationDate: $evaluationDate) {
    id
    externalId
    commitmentAmount
    topupThreshold
    selloutThreshold
    creditPolicyId
    evaluationAssetSummary {
      assetType
      marketValue
      collateralValue
      advanceRate
      id
    }
  }
}
    `;
export const useSaveEvaluationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SaveEvaluationMutation, TError, SaveEvaluationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SaveEvaluationMutation, TError, SaveEvaluationMutationVariables, TContext>(
      ['saveEvaluation'],
      (variables?: SaveEvaluationMutationVariables) => fetcher<SaveEvaluationMutation, SaveEvaluationMutationVariables>(client, SaveEvaluationDocument, variables, headers)(),
      options
    );
useSaveEvaluationMutation.getKey = () => ['saveEvaluation'];

export const UnpledgedAccountsDocument = `
    query unpledgedAccounts($customerId: String!, $systemAccountIds: [String!]!) {
  unpledgedAccounts(customerId: $customerId, systemAccountIds: $systemAccountIds) {
    records {
      account {
        id
        collateralAccountId
        accountType
        custodian
        currency
        pledged
        source
        ownerId
        ownerDisplayName
        assetHoldings {
          securityId
          quantity
          assetType
        }
      }
      errors
    }
    warning
  }
}
    `;
export const useUnpledgedAccountsQuery = <
      TData = UnpledgedAccountsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UnpledgedAccountsQueryVariables,
      options?: UseQueryOptions<UnpledgedAccountsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<UnpledgedAccountsQuery, TError, TData>(
      ['unpledgedAccounts', variables],
      fetcher<UnpledgedAccountsQuery, UnpledgedAccountsQueryVariables>(client, UnpledgedAccountsDocument, variables, headers),
      options
    );
useUnpledgedAccountsQuery.document = UnpledgedAccountsDocument;


useUnpledgedAccountsQuery.getKey = (variables: UnpledgedAccountsQueryVariables) => ['unpledgedAccounts', variables];
;

export const UnpledgedAccountsManyCustomersDocument = `
    query unpledgedAccountsManyCustomers($customerIds: [String!]!, $systemAccountIds: [String!]!) {
  unpledgedAccountsManyCustomers(
    customerIds: $customerIds
    systemAccountIds: $systemAccountIds
  ) {
    records {
      account {
        id
        collateralAccountId
        accountType
        custodian
        currency
        pledged
        source
        ownerId
        assetHoldings {
          securityId
          quantity
          assetType
        }
      }
      errors
    }
    warning
  }
}
    `;
export const useUnpledgedAccountsManyCustomersQuery = <
      TData = UnpledgedAccountsManyCustomersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UnpledgedAccountsManyCustomersQueryVariables,
      options?: UseQueryOptions<UnpledgedAccountsManyCustomersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<UnpledgedAccountsManyCustomersQuery, TError, TData>(
      ['unpledgedAccountsManyCustomers', variables],
      fetcher<UnpledgedAccountsManyCustomersQuery, UnpledgedAccountsManyCustomersQueryVariables>(client, UnpledgedAccountsManyCustomersDocument, variables, headers),
      options
    );
useUnpledgedAccountsManyCustomersQuery.document = UnpledgedAccountsManyCustomersDocument;


useUnpledgedAccountsManyCustomersQuery.getKey = (variables: UnpledgedAccountsManyCustomersQueryVariables) => ['unpledgedAccountsManyCustomers', variables];
;

export const AlertsSummaryDocument = `
    query alertsSummary($dataBarrierFunctionality: DataBarrierFunctionality) {
  alertsSummary(dataBarrierFunctionality: $dataBarrierFunctionality) {
    status
    count
  }
}
    `;
export const useAlertsSummaryQuery = <
      TData = AlertsSummaryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AlertsSummaryQueryVariables,
      options?: UseQueryOptions<AlertsSummaryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AlertsSummaryQuery, TError, TData>(
      variables === undefined ? ['alertsSummary'] : ['alertsSummary', variables],
      fetcher<AlertsSummaryQuery, AlertsSummaryQueryVariables>(client, AlertsSummaryDocument, variables, headers),
      options
    );
useAlertsSummaryQuery.document = AlertsSummaryDocument;


useAlertsSummaryQuery.getKey = (variables?: AlertsSummaryQueryVariables) => variables === undefined ? ['alertsSummary'] : ['alertsSummary', variables];
;

export const LoanCommentsDocument = `
    query loanComments($loanId: String!) {
  loanComments(loanId: $loanId) {
    text
    date
  }
}
    `;
export const useLoanCommentsQuery = <
      TData = LoanCommentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: LoanCommentsQueryVariables,
      options?: UseQueryOptions<LoanCommentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<LoanCommentsQuery, TError, TData>(
      ['loanComments', variables],
      fetcher<LoanCommentsQuery, LoanCommentsQueryVariables>(client, LoanCommentsDocument, variables, headers),
      options
    );
useLoanCommentsQuery.document = LoanCommentsDocument;


useLoanCommentsQuery.getKey = (variables: LoanCommentsQueryVariables) => ['loanComments', variables];
;

export const LoanSummaryDocument = `
    query loanSummary($customerID: String!) {
  customer(customerId: $customerID) {
    customerId
    weightedInterestRate
    serviceStatus {
      priority
      status
      severity
    }
    opportunity {
      lendableAmount
      potentialToBorrow
      totalRemainingMarketValue
      totalRemainingEligibleMarketValue
    }
    pledgedAccountSummary {
      totalMarketValue
      totalEligibleMarketValue
      totalCollateralValue
    }
    portfolioSummary {
      numberOfLoans
      utilizationRate
      totalCommitment
      totalOutstandingBalance
      availability
    }
    loans {
      id
      obligor
      obligation
      status
      commitmentAmount
      outstandingBalance
      isCrossCollateralised
      loanCollateral {
        accountId
        collateralAccountId
      }
    }
    collateralAccounts {
      id
    }
  }
}
    `;
export const useLoanSummaryQuery = <
      TData = LoanSummaryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: LoanSummaryQueryVariables,
      options?: UseQueryOptions<LoanSummaryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<LoanSummaryQuery, TError, TData>(
      ['loanSummary', variables],
      fetcher<LoanSummaryQuery, LoanSummaryQueryVariables>(client, LoanSummaryDocument, variables, headers),
      options
    );
useLoanSummaryQuery.document = LoanSummaryDocument;


useLoanSummaryQuery.getKey = (variables: LoanSummaryQueryVariables) => ['loanSummary', variables];
;

export const PartiesDocument = `
    query parties($loanID: String!) {
  loanParties(loanId: $loanID) {
    id
    relationship
    displayName
    customerExternalId
    governmentFederalTaxId
    type
    govId
    collateralAccounts {
      collateralAccountId
    }
  }
}
    `;
export const usePartiesQuery = <
      TData = PartiesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: PartiesQueryVariables,
      options?: UseQueryOptions<PartiesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PartiesQuery, TError, TData>(
      ['parties', variables],
      fetcher<PartiesQuery, PartiesQueryVariables>(client, PartiesDocument, variables, headers),
      options
    );
usePartiesQuery.document = PartiesDocument;


usePartiesQuery.getKey = (variables: PartiesQueryVariables) => ['parties', variables];
;

export const SingleLoanDocument = `
    query singleLoan($loanID: String!, $customerID: String!) {
  customer(customerId: $customerID) {
    displayName
    customerId
    opportunity {
      lendableAmount
      potentialToBorrow
    }
    portfolioSummary {
      numberOfLoans
    }
    collateralAccounts {
      id
    }
  }
  loan(loanId: $loanID) {
    id
    status
    obligor
    obligation
    startDate
    endDate
    productType
    minimumBalance
    commitmentAmount
    outstandingBalance
    compareTo
    marketValue
    eligibleMarketValue
    selloutThreshold
    topupThreshold
    collateralValue
    currentInterestRate
    rateType
    rateIndex
    spread
    floorRate
    paymentAmount
    nextPaymentDueDate
    remainingCollateralValue
    remainingMarketValue
    remainingEligibleMarketValue
    repaymentFixAmount
    fixAmount
    topUpCushion
    isCrossCollateralised
    availability
    utilizationRate
    blendedAdvanceRate
    blendedTopUpRate
    blendedSellOutRate
    currentInterestRate
    rateType
    rateIndex
    spread
    floorRate
    paymentAmount
    nextPaymentDueDate
    accountNumber
    ytdInterestPaid
    interestSinceInception
    dailyInterest
    mtdInterest
    priorYearInterest
    autoRenewable
    loanCollateral {
      accountId
      collateralAccountId
    }
  }
}
    `;
export const useSingleLoanQuery = <
      TData = SingleLoanQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SingleLoanQueryVariables,
      options?: UseQueryOptions<SingleLoanQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SingleLoanQuery, TError, TData>(
      ['singleLoan', variables],
      fetcher<SingleLoanQuery, SingleLoanQueryVariables>(client, SingleLoanDocument, variables, headers),
      options
    );
useSingleLoanQuery.document = SingleLoanDocument;


useSingleLoanQuery.getKey = (variables: SingleLoanQueryVariables) => ['singleLoan', variables];
;

export const LoanProposalDocument = `
    query loanProposal($evaluationId: String!) {
  evaluation(evaluationId: $evaluationId) {
    id
    commitmentAmount
    customerExternalId
  }
  applicationConfig {
    loanProposal {
      minimumLoanAmount
      minimumLoanAmountWarning
      showFields {
        loanAmount
        loanPurpose
        primaryLoanPurpose
        productType
        loanType
        loanTerm
        interestRateType
        proposedPricing
        borrowerType
        floor
        fees
        initialRate
        exceptionRequest
        exceptionRequestRationale
        spread
      }
      fieldsOptions {
        loanPurpose {
          other
          options
          defaultValue
        }
        primaryLoanPurpose {
          options
          defaultValue
        }
        productType {
          options
          defaultValue
        }
        loanType {
          options
          defaultValue
        }
        loanTerm {
          other
          options
        }
        loanIndex {
          fixed
          variable
          defaultValue
        }
        interestRateDefaultValue
        interestRateMarginShow {
          fixed
          variable
        }
        floorShow {
          fixed
          variable
        }
        fixedRatePeriod {
          termOtherShow
          fixedRatePeriodTerm
          initialRateShow
          feesShow
        }
        borrowerType {
          options
          defaultValue
        }
        exceptionRequest {
          options
          defaultValue
        }
        spread
      }
      rates {
        from
        to
        loanType
        loanTerm
        interestRateType
        loanIndex
        rates
        spread
      }
      applicationSubmittedMsg
    }
  }
}
    `;
export const useLoanProposalQuery = <
      TData = LoanProposalQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: LoanProposalQueryVariables,
      options?: UseQueryOptions<LoanProposalQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<LoanProposalQuery, TError, TData>(
      ['loanProposal', variables],
      fetcher<LoanProposalQuery, LoanProposalQueryVariables>(client, LoanProposalDocument, variables, headers),
      options
    );
useLoanProposalQuery.document = LoanProposalDocument;


useLoanProposalQuery.getKey = (variables: LoanProposalQueryVariables) => ['loanProposal', variables];
;

export const ApplicationsListDocument = `
    query applicationsList($fromIndex: Int!, $numResults: Int!, $searchText: String, $sortBy: [ApplicationSearchSortByInput!]) {
  applicationsSearch(
    searchInput: {numResults: $numResults, fromIndex: $fromIndex, sortBy: $sortBy, searchText: $searchText}
  ) {
    items {
      id
      requestedLoanAmount
      lastUpdateDate
      customerName
      customerExternalId
      customerId
      status
      formBundleId
    }
    numResults
    totalHits
  }
}
    `;
export const useApplicationsListQuery = <
      TData = ApplicationsListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ApplicationsListQueryVariables,
      options?: UseQueryOptions<ApplicationsListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ApplicationsListQuery, TError, TData>(
      ['applicationsList', variables],
      fetcher<ApplicationsListQuery, ApplicationsListQueryVariables>(client, ApplicationsListDocument, variables, headers),
      options
    );
useApplicationsListQuery.document = ApplicationsListDocument;


useApplicationsListQuery.getKey = (variables: ApplicationsListQueryVariables) => ['applicationsList', variables];
;

export const EvaluationsListDocument = `
    query evaluationsList($fromIndex: Int!, $numResults: Int!, $searchText: String, $sortBy: [EvaluationSearchSortByInput!]) {
  evaluationsSearch(
    searchInput: {numResults: $numResults, fromIndex: $fromIndex, sortBy: $sortBy, searchText: $searchText}
  ) {
    items {
      id
      commitmentAmount
      lastEvaluated
      customerName
      customerExternalId
      customerId
      status
      externalId
    }
    numResults
    totalHits
  }
}
    `;
export const useEvaluationsListQuery = <
      TData = EvaluationsListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: EvaluationsListQueryVariables,
      options?: UseQueryOptions<EvaluationsListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<EvaluationsListQuery, TError, TData>(
      ['evaluationsList', variables],
      fetcher<EvaluationsListQuery, EvaluationsListQueryVariables>(client, EvaluationsListDocument, variables, headers),
      options
    );
useEvaluationsListQuery.document = EvaluationsListDocument;


useEvaluationsListQuery.getKey = (variables: EvaluationsListQueryVariables) => ['evaluationsList', variables];
;

export const PermissionDocument = `
    query permission {
  userPermissions {
    canViewCustomers
    canViewLoans
    canAccessLoanPdf
    canViewCollateralAccounts
    canViewInternalContacts
    canPerformReleaseRequest
    canPerformDrawdownRequest
    canViewEvaluations
    canCreateModifyRunEvaluations
    canAccessEvaluationPdf
    canCreateLoanApplication
    canAcquireAccountHeldAway
    canAddAccountManually
    canViewApplications
    canViewActivityNotifications
    canDownloadLoanDocs
  }
}
    `;
export const usePermissionQuery = <
      TData = PermissionQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: PermissionQueryVariables,
      options?: UseQueryOptions<PermissionQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PermissionQuery, TError, TData>(
      variables === undefined ? ['permission'] : ['permission', variables],
      fetcher<PermissionQuery, PermissionQueryVariables>(client, PermissionDocument, variables, headers),
      options
    );
usePermissionQuery.document = PermissionDocument;


usePermissionQuery.getKey = (variables?: PermissionQueryVariables) => variables === undefined ? ['permission'] : ['permission', variables];
;
